// IMPORTS
//-------------------------------------------------------------------------------------------------------------------------
//Angular
import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';

//Services
import { CASNavBoxService } from '../../shared/components/cas-navbox/cas-navbox-service';
import { CPDFormatters } from '../../shared/services/cpd-formatters';
//import { FormDataService2 } from '../../shared/services/formData2';
import { Helpers } from '../../shared/services/helpers';
import { WebServices } from '../../shared/services/webServices';
import { FeatureFlagService } from '../../shared/services/featureFlagService';

//Libraries
import { BCGrowls } from '../../shared/library/bcGrowls';
import { CASValidate } from '../../shared/library/casValidate';
import { exportCsvDTO } from '../../shared/library/export';

//Classes
import { ResourceConcern } from "../../shared/classes/resourceConcern.js";

//Bootstrap no longer needed since moving to Angular date picker
//import { NgbDatepickerConfig, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { casNgbDateParserFormatter } from '../../shared/services/cas-NgbDateParserFormatter';

//Config/Globals
import { Enums } from '../../shared/enums.js';
import { appConfig } from '../../shared/appConfig.js';

//Token
import { authToken } from '../../shared/authToken';
import { FormAction } from '../../shared/classes/formAction';


// LOCALS
//-------------------------------------------------------------------------------------------------------------------------


// EXPORTS
//-------------------------------------------------------------------------------------------------------------------------
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// ResourceManagementComponent
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
@Component({
    selector: 'resource-management',
    template : '<div class="rcm-main-content-div" data-test-id="content_resource_management">\n\n    <!--TITLE-->\n    <h2 tabindex="-1" class="cpd-title-div">{{_title}}</h2>\n\n\n    <!--Content Loading -->\n    <div *ngIf="casNavBoxService.ActionsLoading || _pageLoading" class="cpd-ui-content-loading">\n        <img src="public/cpd-images/loading.gif" />\n        <div style="margin-left:10px;">Loading...</div>\n    </div>\n\n    <!--CONTENT CONTAINER-->\n    <ng-container *ngIf="!_pageLoading">\n\n        <!--View Control-->\n        <div class="rcm-control-div-alt-2" role="radiogroup" aria-labelledby="divRadioLabel">\n\n            <div id="divRadioLabel">View:</div>\n\n            <!--CONCERN CATEGORIES-->\n            <div class="rcm-filter-radio">\n                <input tabindex="0" id="rdoShowCategories" type="radio" value="categories" name="optView" [(ngModel)]="_currentView" (change)="selectedView_changed(\'categories\')" />\n                <label for="rdoShowCategories" aria-label="Show Resource Concern Categories" class="cpd-focusable">Resource Concern Categories</label>\n            </div>\n\n            <!--CONCERNS-->\n            <div class="rcm-filter-radio">\n                <input tabindex="0" id="rdoShowConcerns" type="radio" value="concerns" name="optView" [(ngModel)]="_currentView" (change)="selectedView_changed(\'concerns\')" />\n                <label for="rdoShowConcerns" aria-label="Show Resource Concerns" class="cpd-focusable">Resource Concerns</label>\n            </div>\n\n            <!--COMPONENTS-->\n            <div class="rcm-filter-radio">\n                <input tabindex="0" id="rdoShowComponents" type="radio" value="components" name="optView" [(ngModel)]="_currentView" (change)="selectedView_changed(\'components\')" />\n                <label for="rdoShowComponents" aria-label="Show Resource Concern Components" class="cpd-focusable">Resource Concern Components</label>\n            </div>\n\n        </div>\n\n        <!--Fiscal Year-->\n        <div class="rcm-control-div">\n\n            <!--fiscal year selection-->\n            <div class="cpd-control-unit" style="margin-right:10px;">\n                <label for="selFiscalYear" class="cpd-ui-field-div-lbl">Fiscal Year:</label>\n                <select id="selFiscalYear" [disabled]="_disableControls" [(ngModel)]="_selectedFiscalYear" (change)="ddl_selectedFiscalYear_changed($event);">\n                    <option *ngFor="let fy of _fiscalYears;" [ngValue]="fy">{{fy}}</option>\n                </select>\n            </div>\n\n            <div style="font-style:italic;">Applies to all views</div>\n\n        </div>\n\n        <div style="border-bottom:dotted 1px #ccc; margin:10px 10px;"></div>\n\n        <!--============================================================================-->\n        <!--VIEW: Category-->\n        <!--============================================================================-->\n        <ng-container *ngIf="_currentView==\'categories\'">\n\n            <!--Grid-->\n            <div class="rcm-resource-grid-div">\n                <cas-grid #categoryGrid\n                          summary="Resource Concern Category List"\n                          (onRefreshClicked)="categoryGrid_refreshClicked()"\n                          [settings]="_categoryGridSettings"></cas-grid>\n            </div>\n\n        </ng-container>\n\n        <!--============================================================================-->\n        <!--VIEW: Concerns-->\n        <!--============================================================================-->\n        <ng-container *ngIf="_currentView==\'concerns\'">\n\n            <!--Sub Controls-->\n            <div class="rcm-control-div-alt-1">\n\n                <!--swapa category selection-->\n                <div class="cpd-control-unit" style="margin-right:30px;">\n                    <label for="selSwapa" class="cpd-ui-field-div-lbl">SWAPAE+H Category:</label>\n                    <select id="selSwapa" [disabled]="_disableControls" [(ngModel)]="_selectedSwapaCategory_concernView">\n                        <option *ngFor="let swapa of _swapaCategories_concernView;" [ngValue]="swapa">{{swapa.swapa_category_name}}</option>\n                    </select>\n                </div>\n\n                <!--resource concern category selection-->\n                <div class="cpd-control-unit" style="margin-right:30px;">\n                    <label for="selResourceConcernCategory" class="cpd-ui-field-div-lbl">Concern Category:</label>\n                    <select id="selResourceConcernCategory" [disabled]="_disableControls" [(ngModel)]="_selectedConcernCategory_concernView">\n                        <option *ngFor="let category of _concernCategories_concernView;" [ngValue]="category">{{category.resource_concern_category_display}}</option>\n                    </select>\n                </div>\n\n                <div style="width:20px;"></div>\n\n                <!--GO BUTTON -->\n                <button type="button" class="btn btn-primary" [disabled]="_disableControls" (click)="concernView_goButtonClicked()">GO</button>\n\n            </div>\n\n            <!--Grid-->\n            <div class="rcm-resource-grid-div">\n                <cas-grid #concernGrid\n                          summary="Resource Concern List"\n                          [settings]="_concernGridSettings"\n                          (onRefreshClicked)="concernGrid_refreshClicked()">\n                </cas-grid>\n            </div>\n\n        </ng-container>\n\n        <!--============================================================================-->\n        <!--VIEW: Components-->\n        <!--============================================================================-->\n        <ng-container *ngIf="_currentView==\'components\'">\n            <!--Sub Controls-->\n            <div class="rcm-control-div-alt-1">\n\n                <!--resource concern selection-->\n                <div class="cpd-control-unit" style="margin-right:30px;">\n                    <label for="selResourceConcern" class="cpd-ui-field-div-lbl">Resource Concern:</label>\n                    <select id="selResourceConcern" [disabled]="_disableControls" [(ngModel)]="_selectedResourceConcern_componentView">\n                        <option *ngFor="let concern of _resourceConcerns_componentView;" [ngValue]="concern">{{concern.resource_concern_display}}</option>\n                    </select>\n                </div>\n\n                <div style="width:20px;"></div>\n\n                <!--GO BUTTON -->\n                <button type="button" class="btn btn-primary" [disabled]="_disableControls" (click)="componentView_goButtonClicked()">GO</button>\n\n            </div>\n\n            <!--Grid-->\n            <div class="rcm-resource-grid-div">\n                <cas-grid #componentGrid\n                          summary="Resource Concern Component List"\n                          [settings]="_componentGridSettings"\n                          (onRowSelectionChanged)="onRowSelectionChanged()"\n                          (onRefreshClicked)="componentGrid_refreshClicked()">\n                </cas-grid>\n            </div>\n        </ng-container>\n\n    </ng-container>\n\n\n    <!--POPUP INSTANCE CONTAINER-->\n    <!--When the Modal component inserts the Angular component that wraps the Bootstrap popups, it needs to go somewhere\n    where it will be cleared when the user navigates away from this page.  Note that the popup elements inserted here\n    are moved to the \'body\' when displayed and then moved back here when not (so the heat shield/backdrop is under them in z-order).-->\n    <div id="resource_management_page_popups"></div>\n\n    <!--========================================-->\n    <!-- Resource Concern Category Popup -->\n    <!--========================================-->\n    <modal #popCategory\n           title="{{ _popupMode == \'edit\' ? \'Edit\' : \'New\' }} Resource Concern Category"\n           containerId="resource_management_page_popups"\n           label="popCategory"\n           customClass="rm-ui-popup-edit-resource">\n\n        <!--FVT-ID-->\n        <section name="fvt_id" style="visibility:hidden;" data-test-id="dialog_resource_management_category"></section>\n\n        <!-- body -->\n        <section>\n\n            <!--For 508-->\n            <div style="position:relative; top:-8px; left:5px;"><span style="color:red;">*</span> indicates a required field</div>\n\n            <!--Single Row display-->\n            <div id="popupCategoryFields" class="cpd-ui-row">\n\n                <!--Single Cell display-->\n                <div class="cpd-ui-cell" style="flex-grow:1; padding-bottom:15px;">\n\n                    <!--Heading-->\n                    <div class="cpd-ui-group-lbl" role="heading" aria-level="5" title="Resource Concern Category Details" attr.aria-label="Resource Concern Category Details">\n                        <h3>Resource Concern Category Details</h3>\n                    </div>\n\n                    <div style="border-top:solid 1px #ccc; margin:10px 0;"></div>\n\n                    <!--Category Name-->\n                    <div class="rm-ui-field-div">\n                        <label for="popCategory_txtCategoryName">\n                            <span aria-label="required" style="color:red;">*</span>\n                            Category Name\n                        </label>\n                        <div>\n                            <input id="popCategory_txtCategoryName"\n                                   [(ngModel)]="_popupTempModels.category.categoryName"\n                                   class="cval rm-ui-field"\n                                   data-cval-msg-element-id="popCategory_txtCategoryName_vmsg"\n                                   data-cval-required="true"\n                                   data-cval-fld-name="Category Name"\n                                   [attr.maxlength]="254"\n                                   (input)="_popupDirty=true;" />\n\n                            <button id="popCategory_butCopyName"\n                                    class="mdi mdi-chevron-down"\n                                    title="Copy Name to Display"\n                                    (click)="popCategory_butCopyName_clicked()"></button>\n                        </div>\n                        <div id="popCategory_txtCategoryName_vmsg" class="cval-validation-message" style="padding-left:10px;"></div>\n                    </div>\n\n                    <!--Category Display-->\n                    <div class="rm-ui-field-div">\n                        <label for="popCategory_txtCategoryDisplay">\n                            <span aria-label="required" style="color:red;">*</span>\n                            Category Display\n                        </label>\n                        <div>\n                            <input id="popCategory_txtCategoryDisplay"\n                                   [(ngModel)]="_popupTempModels.category.categoryDisplay"\n                                   class="cval rm-ui-field"\n                                   data-cval-msg-element-id="popCategory_txtCategoryDisplay_vmsg"\n                                   data-cval-required="true"\n                                   data-cval-fld-name="Category Display"\n                                   [attr.maxlength]="254"\n                                   (input)="_popupDirty = true;" />\n                        </div>\n                        <div id="popCategory_txtCategoryDisplay_vmsg" class="cval-validation-message" style="padding-left:10px;"></div>\n                    </div>\n\n                    <!--Resource Concern Category - Dates Block-->\n                    <div class="rm-ui-dates-block">\n\n                        <!--Start Date-->\n                        <div class="rm-ui-flex-field-div" style="margin-left:2px;">\n                            <label for="rccat_start_date" class="rm-ui-flex-field-lbl">\n                                <span aria-label="required" style="color:red;">*</span>\n                                Start Date:&nbsp;\n                            </label>\n                            <div class="cpd-ui-field-div">\n                                <input type="date"\n                                       [min]="_today"\n                                       placeholder="m/d/yyyy"\n                                       id="rccat_start_date" name="categoryStartDate"\n                                       data-cval-msg-element-id="rccat_start_date_vmsg"\n                                       data-cval-fld-name="Start Date"\n                                       [attr.data-cval-required]="true"\n                                       [attr.data-cval-date]="true"\n                                       style="width:140px;"\n                                       aria-label="Start date (format m/d/yyyy)"\n                                       (input)="_popupDirty = true;"\n                                       class="cval form-control"\n                                       [ngModel]="_popupTempModels.category.categoryStartDate"\n                                       (ngModelChange)="_popupTempModels.category.categoryStartDate=$event; _formChanged(\'popCategory_body\')" />\n\n                            </div>\n                        </div>\n\n                        <!--Spacer-->\n                        <div style="width:10px;"></div>\n\n                        <!--End Date-->\n                        <div class="rm-ui-flex-field-div" style="margin-left:2px;">\n                            <label for="rccat_end_date" class="rm-ui-flex-field-lbl">End Date:&nbsp;</label>\n                            <div class="cpd-ui-field-div">\n                                <input type="date"\n                                       [min]="_today"\n                                       placeholder="m/d/yyyy"\n                                       id="rccat_end_date" name="categoryEndDate"\n                                       data-cval-msg-element-id="rccat_end_date_vmsg"\n                                       data-cval-fld-name="End Date"\n                                       [attr.data-cval-required]="false"\n                                       [attr.data-cval-date]="true"\n                                       style="width:140px;"\n                                       aria-label="End date (format m/d/yyyy)"\n                                       (input)="_popupDirty = true;"\n                                       class="cval form-control"\n                                       [ngModel]="_popupTempModels.category.categoryEndDate"\n                                       (ngModelChange)="_popupTempModels.category.categoryEndDate=$event; _formChanged(\'popCategory_body\')" />\n\n                            </div>\n                        </div>\n\n                        <!--Spacer-->\n                        <div style="width:15px;"></div>\n\n                        <!--Publish-->\n                        <div class="rm-ui-flex-field-div">\n                            <label for="popCategory_chkCateoryPublish" class="rm-ui-flex-field-lbl">Publish:&nbsp;</label>\n                            <input *ngIf="!!_popupTempModels.category.categoryPublishOriginal" \n                                   aria-disabled="true"\n                                   aria-label="Publish checkbox" \n                                   type="checkbox"\n                                   onclick="return false"\n                                   role="application"\n                                   id="popCategory_chkCateoryPublish"\n                                   name="popCategory_chkCateoryPublish"\n                                   [(ngModel)]="_popupTempModels.category.categoryPublish"\n                                   />\n                            <input *ngIf="!_popupTempModels.category.categoryPublishOriginal" tabindex="0" type="checkbox"\n                                   id="popCategory_chkCateoryPublish"\n                                   name="popCategory_chkCateoryPublish"\n                                   [(ngModel)]="_popupTempModels.category.categoryPublish"\n                                   (click)="_popupDirty = true;"\n                                   (input)="_popupDirty = true;" />\n                        </div>\n\n                    </div>\n\n                    <!--Category Start Date validation message-->\n                    <div id="rccat_start_date_vmsg" class="cval-validation-message" style="padding-left:10px;"></div>\n                    <!--Category End Date validation message-->\n                    <div id="rccat_end_date_vmsg" class="cval-validation-message" style="padding-left:10px;"></div>\n\n                </div>\n            </div>\n\n        </section>\n\n        <!-- footer -->\n        <footer>\n            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>\n            <button type="button" accesskey="s" class="btn btn-primary" (click)="saveCategory()"><u>S</u>ave</button>\n        </footer>\n\n    </modal>\n\n    <!--========================================-->\n    <!-- Resource Component Popup -->\n    <!--========================================-->\n    <modal #popComponent\n           containerId="resource_management_page_popups"\n           title="{{ _popupMode == \'edit\' ? \'Edit\' : \'New\' }} Resource Concern Component"\n           label="popComponent"\n           customClass="rm-ui-popup-edit-resource">\n\n        <!--FVT-ID-->\n        <section name="fvt_id" style="visibility:hidden;" data-test-id="dialog_resource_management_component"></section>\n\n        <!-- body -->\n        <section>\n\n            <!--For 508-->\n            <div style="position:relative; top:-8px; left:5px;"><span style="color:red;">*</span> indicates a required field</div>\n\n            <!--Single Row display-->\n            <div id="popupComponentFields" class="cpd-ui-row">\n\n                <!--Single Cell display-->\n                <div class="cpd-ui-cell" style="flex-grow:1;">\n\n                    <!--Heading-->\n                    <div class="cpd-ui-group-lbl" role="heading" aria-level="5" title="Resource Concern Component Details" attr.aria-label="Resource Concern Component Details">\n                        <h3>Resource Concern Component Details</h3>\n                    </div>\n\n                    <div style="border-top:solid 1px #ccc; margin:10px 0;"></div>\n\n                    <!--Resource Concern NEW/EDIT-->\n                    <!--Resource Concern: EDIT-->\n                    <ng-container *ngIf="_popupMode == \'edit\'">\n                        <div class="cpd-control-unit" style="margin:0 30px 10px 0;">\n                            <label for="popupConcern_selResourceConcernComponent" style="width:125px;" class="cpd-ui-field-div-lbl">Resource Concern:</label>\n                            <select id="popupConcern_selResourceConcernComponent" style="max-width:350px;" [disabled]="_disableControls" [(ngModel)]="_popupTempModels.component.componentConcernId" (change)="_popupDirty=true;">\n                                <option *ngFor="let concern of _resourceConcerns_componentPopup_edit;" [ngValue]="concern.resource_concern_id">{{concern.resource_concern_display}}</option>\n                            </select>\n                        </div>\n                    </ng-container>\n\n                    <!--Resource Concern: NEW-->\n                    <ng-container *ngIf="_popupMode == \'new\'">\n                        <div class="cpd-control-unit" style="margin:0 30px 10px 0;">\n                            <label for="popupConcern_selResourceConcernComponent" style="width:125px;" class="cpd-ui-field-div-lbl">Resource Concern:</label>\n                            <select id="popupConcern_selResourceConcernComponent" style="max-width:350px;" [disabled]="_disableControls" [(ngModel)]="_popupTempModels.component.componentConcernId" (change)="_popupDirty=true;">\n                                <option *ngFor="let concern of _resourceConcerns_componentPopup_new;" [ngValue]="concern.resource_concern_id">{{concern.resource_concern_display}}</option>\n                            </select>\n                        </div>\n                    </ng-container>\n\n                    <div style="border-top:solid 1px #ccc; margin:10px 0;"></div>\n\n                    <!--Component Name-->\n                    <div class="rm-ui-field-div">\n                        <label for="popComponent_txtComponentName">\n                            <span aria-label="required" style="color:red;">*</span>\n                            Component Name\n                        </label>\n                        <div>\n                            <input id="popComponent_txtComponentName"\n                                   [(ngModel)]="_popupTempModels.component.componentName"\n                                   class="cval rm-ui-field"\n                                   data-cval-msg-element-id="popComponent_txtComponentName_vmsg"\n                                   data-cval-required="true"\n                                   data-cval-fld-name="Component Name"\n                                   [attr.maxlength]="254"\n                                   (input)="_popupDirty=true;" />\n\n                            <button id="popComponent_butCopyName"\n                                    class="mdi mdi-chevron-down"\n                                    title="Copy Name to Display"\n                                    (click)="popComponent_butCopyName_clicked()"></button>\n                        </div>\n                        <div id="popComponent_txtComponentName_vmsg" class="cval-validation-message" style="padding-left:10px;"></div>\n                    </div>\n\n                    <!--Component Display-->\n                    <div class="rm-ui-field-div">\n                        <label for="popComponent_txtComponentDisplay">\n                            <span aria-label="required" style="color:red;">*</span>\n                            Component Display\n                        </label>\n                        <div>\n                            <input id="popComponent_txtComponentDisplay"\n                                   [(ngModel)]="_popupTempModels.component.componentDisplay"\n                                   class="cval rm-ui-field"\n                                   data-cval-msg-element-id="popComponent_txtComponentDisplay_vmsg"\n                                   data-cval-required="true"\n                                   data-cval-fld-name="Component Display"\n                                   [attr.maxlength]="254"\n                                   (input)="_popupDirty=true;" />\n                        </div>\n                        <div id="popComponent_txtComponentDisplay_vmsg" class="cval-validation-message" style="padding-left:10px;"></div>\n                    </div>\n\n                    <!--Component Description-->\n                    <div class="rm-ui-field-div">\n                        <label for="popComponent_txtComponentDescription">\n                            <span>&nbsp;&nbsp;</span>\n                            Component Description\n                        </label>\n                        <div>\n                            <textarea id="popComponent_txtComponentDescription"\n                                      [(ngModel)]="_popupTempModels.component.componentDescription"\n                                      class="cval rm-ui-field"\n                                      data-cval-msg-element-id="popComponent_txtComponentDescription_vmsg"\n                                      data-cval-required="false"\n                                      data-cval-fld-name="Component Description"\n                                      [attr.maxlength]="499"\n                                      rows="6"\n                                      cols="1"\n                                      (input)="_popupDirty=true;"></textarea>\n                        </div>\n                        <div id="popComponent_txtComponentDescription_vmsg" class="cval-validation-message" style="padding-left:10px;"></div>\n                    </div>\n\n                    <!--Component Objective-->\n                    <div class="rm-ui-field-div">\n                        <label for="popComponent_txtComponentObjective">\n                            <span>&nbsp;&nbsp;</span>\n                            Component Objective\n                        </label>\n                        <div>\n                            <textarea id="popComponent_txtComponentObjective"\n                                      [(ngModel)]="_popupTempModels.component.componentObjective"\n                                      class="cval rm-ui-field"\n                                      data-cval-msg-element-id="popComponent_txtComponentObjective_vmsg"\n                                      data-cval-required="false"\n                                      data-cval-fld-name="Component Objective"\n                                      [attr.maxlength]="499"\n                                      rows="6"\n                                      cols="1"\n                                      (input)="_popupDirty=true;"></textarea>\n                        </div>\n                        <div id="popComponent_txtComponentObjective_vmsg" class="cval-validation-message" style="padding-left:10px;"></div>\n                    </div>\n\n                    \n                    <!--Resource Component - Dates Block-->\n                    <div class="rm-ui-dates-block">\n\n                        <!--Start Date-->\n                        <div class="rm-ui-flex-field-div" style="margin-left:5px;">\n                            <label for="rcc_start_date" class="rm-ui-flex-field-lbl">\n                                <span aria-label="required" style="color:red;">*</span>\n                                Start Date:&nbsp;\n                            </label>\n                            <div class="cpd-ui-field-div">\n                                <input type="date"\n                                       [min]="_today"\n                                       placeholder="m/d/yyyy"\n                                       id="rcc_start_date" name="componentStartDate"\n                                       data-cval-msg-element-id="rcc_start_date_vmsg"\n                                       data-cval-fld-name="Start Date"\n                                       [attr.data-cval-required]="true"\n                                       [attr.data-cval-date]="true"\n                                       style="width:140px;"\n                                       aria-label="Start date (format m/d/yyyy)"\n                                       (input)="_popupDirty = true;"\n                                       class="cval form-control"\n                                       [ngModel]="_popupTempModels.component.componentStartDate"\n                                       (ngModelChange)="_popupTempModels.component.componentStartDate=$event; _formChanged(\'popComponent_body\')" />\n\n                            </div>\n                        </div>\n\n                        <!--Spacer-->\n                        <div style="width:20px;"></div>\n\n                        <!--End Date-->\n                        <div class="rm-ui-flex-field-div" style="margin-left:5px;">\n                            <label for="rcc_end_date" class="rm-ui-flex-field-lbl">End Date:&nbsp;</label>\n                            <div class="cpd-ui-field-div">\n                                <input type="date"\n                                       [min]="_today"\n                                       placeholder="m/d/yyyy"\n                                       id="rcc_end_date" name="componentEndDate"\n                                       data-cval-msg-element-id="rcc_end_date_vmsg"\n                                       data-cval-fld-name="End Date"\n                                       [attr.data-cval-required]="false"\n                                       [attr.data-cval-date]="true"\n                                       style="width:140px;"\n                                       aria-label="End date (format m/d/yyyy)"\n                                       (input)="_popupDirty = true;"\n                                       class="cval form-control"\n                                       [ngModel]="_popupTempModels.component.componentEndDate"\n                                       (ngModelChange)="_popupTempModels.component.componentEndDate=$event; _formChanged(\'popComponent_body\')" />\n\n                            </div>\n                        </div>\n\n                    </div>\n\n                    <!--Component Start Date validation message-->\n                    <div id="rcc_start_date_vmsg" class="cval-validation-message" style="padding-left:10px;"></div>\n                    <!--Component End Date validation message-->\n                    <div id="rcc_end_date_vmsg" class="cval-validation-message" style="padding-left:10px;"></div>\n\n\n                    <div style="border-top:solid 1px #ccc; margin:5px 0;"></div>\n\n                    <!--Checkbox Block-->\n                    <div class="rm-ui-checks-block" style="padding:3px 0 3px 0;">\n\n                        <!--Publish-->\n                        <div class="rm-ui-flex-field-div" style="margin-left:5px;">\n                            <label for="popComponent_chkComponentPublish" class="rm-ui-flex-field-lbl">Publish:&nbsp;</label>\n                            <input *ngIf="!!_popupTempModels.component.componentPublishOriginal" \n                                   aria-disabled="true"\n                                   aria-label="Publish checkbox" \n                                   type="checkbox"\n                                   onclick="return false"\n                                   role="application"\n                                   id="popComponent_chkComponentPublish"\n                                   name="popComponent_chkComponentPublish"\n                                   [(ngModel)]="_popupTempModels.component.componentPublish"\n                                   />\n                            <input *ngIf="!_popupTempModels.component.componentPublishOriginal" tabindex="0" type="checkbox"\n                                   id="popComponent_chkComponentPublish"\n                                   name="popComponent_chkComponentPublish"\n                                   [(ngModel)]="_popupTempModels.component.componentPublish"\n                                   (click)="_popupDirty = true;"\n                                   (input)="_popupDirty = true;" />\n                        </div>\n\n                    </div>\n\n                </div><!--End Cell-->\n            </div>\n\n        </section>\n\n        <!-- footer -->\n        <footer>\n            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>\n            <button type="button" accesskey="s" class="btn btn-primary" (click)="saveComponent()"><u>S</u>ave</button>\n        </footer>\n\n    </modal>\n\n    <!--========================================-->\n    <!-- Resource Concern Popup -->\n    <!--========================================-->\n    <modal #popConcern\n           containerId="resource_management_page_popups"\n           title="{{ _popupMode == \'edit\' ? \'Edit\' : \'New\' }} Resource Concern"\n           label="popConcern"\n           customClass="rm-ui-popup-edit-resource">\n\n\n        <!--FVT-ID-->\n        <section name="fvt_id" style="visibility:hidden;" data-test-id="dialog_resource_management_concern"></section>\n\n        <!-- body -->\n        <section>\n\n            <!--For 508-->\n            <div style="position:relative; top:-8px; left:5px;"><span style="color:red;">*</span> indicates a required field</div>\n\n            <!--Single Row display-->\n            <div id="popupConcernFields" class="cpd-ui-row">\n\n                <!--Single Cell display-->\n                <div class="cpd-ui-cell" style="flex-grow:1;">\n\n                    <!--Heading-->\n                    <div class="cpd-ui-group-lbl" role="heading" aria-level="5" title="Resource Concern Details" attr.aria-label="Resource Concern Details">\n                        <h3>Resource Concern Details</h3>\n                    </div>\n\n                    <div style="border-top:solid 1px #ccc; margin:10px 0;"></div>\n\n                    <!--SWAPA Category-->\n                    <div class="cpd-control-unit" style="margin:0 30px 10px 0;">\n                        <label for="popupConcern_selSwapa" style="width:125px;" class="cpd-ui-field-div-lbl">SWAPAE+H Category:</label>\n                        <select id="popupConcern_selSwapa" [disabled]="_disableControls" [(ngModel)]="_popupTempModels.concern.concernSwapaCategoryId" (change)="_popupDirty=true;">\n                            <option *ngFor="let swapa of _swapaCategories_concernPopup;" [ngValue]="swapa.swapa_category_id">{{swapa.swapa_category_name}}</option>\n                        </select>\n                    </div>\n\n                    <!--Display a different list based on new / edit-->\n                    <ng-container *ngIf="_popupMode == \'edit\'">\n\n                        <!--Resource Category - Edit -->\n                        <div class="cpd-control-unit" style="margin:0 30px 10px 0;">\n                            <label for="popupConcern_selResourceConcernCategory1" style="width:125px;" class="cpd-ui-field-div-lbl">Concern Category:</label>\n                            <select id="popupConcern_selResourceConcernCategory1" style="max-width:300px;" [disabled]="_disableControls" [(ngModel)]="_popupTempModels.concern.concernCategoryId" (change)="_popupDirty=true;">\n                                <option *ngFor="let category of _concernCategories_concernPopup_edit;" [ngValue]="category.resource_concern_category_id">{{category.resource_concern_category_display}}</option>\n                            </select>\n                        </div>\n\n                    </ng-container>\n\n                    <ng-container *ngIf="_popupMode == \'new\'">\n                        <!--Resource Category - New -->\n                        <div class="cpd-control-unit" style="margin:0 30px 10px 0;">\n                            <label for="popupConcern_selResourceConcernCategory2" style="width:125px;" class="cpd-ui-field-div-lbl">Concern Category:</label>\n                            <select id="popupConcern_selResourceConcernCategory2" style="max-width:300px;" [disabled]="_disableControls" [(ngModel)]="_popupTempModels.concern.concernCategoryId" (change)="_popupDirty=true;">\n                                <option *ngFor="let category of _concernCategories_concernPopup_new;" [ngValue]="category.resource_concern_category_id">{{category.resource_concern_category_display}}</option>\n                            </select>\n                        </div>\n\n                    </ng-container>\n\n\n                    <div style="border-top:solid 1px #ccc; margin:10px 0;"></div>\n\n                    <!--Concern Name-->\n                    <div class="rm-ui-field-div">\n                        <label for="popConcern_txtConcernName">\n                            <span aria-label="required" style="color:red;">*</span>\n                            Concern Name\n                        </label>\n                        <div>\n                            <input id="popConcern_txtConcernName"\n                                   [(ngModel)]="_popupTempModels.concern.concernName"\n                                   class="cval rm-ui-field"\n                                   data-cval-msg-element-id="popConcern_txtConcernName_vmsg"\n                                   data-cval-required="true"\n                                   data-cval-fld-name="Concern Name"\n                                   [attr.maxlength]="254"\n                                   (input)="_popupDirty=true;" />\n\n                            <button id="popConcern_butCopyName"\n                                    class="mdi mdi-chevron-down"\n                                    title="Copy Name to Display"\n                                    (click)="popConcern_butCopyName_clicked()"></button>\n                        </div>\n                        <div id="popConcern_txtConcernName_vmsg" class="cval-validation-message" style="padding-left:10px;"></div>\n                    </div>\n\n                    <!--Concern Display-->\n                    <div class="rm-ui-field-div">\n                        <label for="popConcern_txtConcernDisplay">\n                            <span aria-label="required" style="color:red;">*</span>\n                            Concern Display\n                        </label>\n                        <div>\n                            <input id="popConcern_txtConcernDisplay"\n                                   [(ngModel)]="_popupTempModels.concern.concernDisplay"\n                                   class="cval rm-ui-field"\n                                   data-cval-msg-element-id="popConcern_txtConcernDisplay_vmsg"\n                                   data-cval-required="true"\n                                   data-cval-fld-name="Concern Display"\n                                   [attr.maxlength]="254"\n                                   (input)="_popupDirty = true;" />\n                        </div>\n                        <div id="popConcern_txtConcernDisplay_vmsg" class="cval-validation-message" style="padding-left:10px;"></div>\n                    </div>\n\n                    <!--Concern Description-->\n                    <div class="rm-ui-field-div">\n                        <label for="popConcern_txtConcernDescription">\n                            <span>&nbsp;&nbsp;</span>\n                            Concern Description\n                        </label>\n                        <div>\n                            <textarea id="popConcern_txtConcernDescription"\n                                      [(ngModel)]="_popupTempModels.concern.concernDescription"\n                                      class="cval rm-ui-field"\n                                      data-cval-msg-element-id="popConcern_txtConcernDescription_vmsg"\n                                      data-cval-required="false"\n                                      data-cval-fld-name="Concern Description"\n                                      [attr.maxlength]="499"\n                                      rows="6"\n                                      cols="1"\n                                      (input)="_popupDirty = true;"></textarea>\n                        </div>\n                        <div id="popConcern_txtConcernDescription_vmsg" class="cval-validation-message" style="padding-left:10px;"></div>\n                    </div>\n\n                    <!--Concern Objective-->\n                    <div class="rm-ui-field-div">\n                        <label for="popConcern_txtConcernObjective">\n                            <span>&nbsp;&nbsp;</span>\n                            Concern Objective\n                        </label>\n                        <div>\n                            <textarea id="popConcern_txtConcernObjective"\n                                      [(ngModel)]="_popupTempModels.concern.concernObjective"\n                                      class="cval rm-ui-field"\n                                      data-cval-msg-element-id="popConcern_txtConcernObjective_vmsg"\n                                      data-cval-required="false"\n                                      data-cval-fld-name="Concern Objective"\n                                      [attr.maxlength]="499"\n                                      rows="6"\n                                      cols="1"\n                                      (input)="_popupDirty=true;"></textarea>\n                        </div>\n                        <div id="popConcern_txtConcernObjective_vmsg" class="cval-validation-message" style="padding-left:10px;"></div>\n                    </div>\n\n                    <!--Resource Concern - Dates Block-->\n                    <div class="rm-ui-dates-block">\n\n                        <!--Start Date-->\n                        <div class="rm-ui-flex-field-div" style="margin-left:5px;">\n                            <label for="rc_start_date" class="rm-ui-flex-field-lbl">\n                                <span aria-label="required" style="color:red;">*</span>\n                                Start Date:&nbsp;\n                            </label>\n                            <div class="cpd-ui-field-div">\n                                <input type="date"\n                                       [min]="_today"\n                                       placeholder="m/d/yyyy"\n                                       id="rc_start_date" name="concernStartDate"\n                                       data-cval-msg-element-id="rc_start_date_vmsg"\n                                       data-cval-fld-name="Start Date"\n                                       [attr.data-cval-required]="true"\n                                       [attr.data-cval-date]="true"\n                                       style="width:140px;"\n                                       aria-label="Start date (format m/d/yyyy)"\n                                       (input)="_popupDirty = true;"\n                                       class="cval form-control"\n                                       [ngModel]="_popupTempModels.concern.concernStartDate"\n                                       (ngModelChange)="_popupTempModels.concern.concernStartDate=$event; _formChanged(\'popConcern_body\')" />\n\n                            </div>\n                        </div>\n\n                        <!--Spacer-->\n                        <div style="width:20px;"></div>\n\n                        <!--End Date-->\n                        <div class="rm-ui-flex-field-div" style="flex-grow:1;">\n                            <label for="rc_end_date" class="rm-ui-flex-field-lbl">End Date:&nbsp;</label>\n                            <div class="cpd-ui-field-div">\n                                <input type="date"\n                                       [min]="_today"\n                                       placeholder="m/d/yyyy"\n                                       id="rc_end_date" name="concernEndDate"\n                                       data-cval-msg-element-id="rc_end_date_vmsg"\n                                       data-cval-fld-name="End Date"\n                                       [attr.data-cval-required]="false"\n                                       [attr.data-cval-date]="true"\n                                       style="width:140px;"\n                                       aria-label="End date (format m/d/yyyy)"\n                                       (input)="_popupDirty = true;"\n                                       class="cval form-control"\n                                       [ngModel]="_popupTempModels.concern.concernEndDate"\n                                       (ngModelChange)="_popupTempModels.concern.concernEndDate=$event; _formChanged(\'popConcern_body\')" />\n\n                            </div>\n                        </div>\n\n                    </div>\n\n                    <!--Concern Start Date validation message-->\n                    <div id="rc_start_date_vmsg" class="cval-validation-message" style="padding-left:10px;"></div>\n                    <!--Concern End Date validation message-->\n                    <div id="rc_end_date_vmsg" class="cval-validation-message" style="padding-left:10px;"></div>\n\n\n                    <div style="border-top:solid 1px #ccc; margin:10px 0;"></div>\n\n                    <!--Checkbox Block-->\n                    <div class="rm-ui-checks-block" style="padding:10px 0 10px 0;">\n\n                        <!--Publish-->\n                        <div class="rm-ui-flex-field-div" style="margin-left:5px;">\n                            <label for="popConcern_chkConcernPublish" class="rm-ui-flex-field-lbl">Publish:&nbsp;</label>\n                            <input *ngIf="!!_popupTempModels.concern.concernPublishOriginal" \n                                   aria-disabled="true"\n                                   aria-label="Publish checkbox" \n                                   type="checkbox"\n                                   onclick="return false"\n                                   role="application"\n                                   id="popConcern_chkConcernPublish"\n                                   name="popConcern_chkConcernPublish"\n                                   [(ngModel)]="_popupTempModels.concern.concernPublish"\n                                   />\n                            <input *ngIf="!_popupTempModels.concern.concernPublishOriginal" tabindex="0" type="checkbox"\n                                   id="popConcern_chkConcernPublish"\n                                   name="popConcern_chkConcernPublish"\n                                   [(ngModel)]="_popupTempModels.concern.concernPublish"\n                                   (click)="_popupDirty = true;"\n                                   (input)="_popupDirty = true;" />\n                        </div>\n\n                    </div>\n\n                </div><!--End Cell-->\n            </div>\n\n        </section>\n\n        <!-- footer -->\n        <footer>\n            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>\n            <button type="button" accesskey="s" class="btn btn-primary" (click)="saveConcern()"><u>S</u>ave</button>\n        </footer>\n\n    </modal>\n\n    <!--========================================-->\n    <!-- Export RCCLU Popup -->\n    <!--========================================-->\n    <modal #popExportRCCLU\n           containerId="resource_management_page_popups"\n           title="Resource Concern Component to Land Use Export"\n           label="popExportRCCLU"\n           customClass="rm-ui-popup-export">\n\n\n        <!--FVT-ID-->\n        <section name="fvt_id" style="visibility:hidden;" data-test-id="dialog_resource_management_export_rcclu"></section>\n\n        <!-- body -->\n        <section>\n\n            <!--For 508-->\n            <div style="position:relative; top:-8px; left:5px; font-style:italic;">All fields are optional. If date is selected, must select both dates<br /></div>\n\n            <!--Resource Concern - Dates Block-->\n            <div class="rm-ui-dates-block">\n\n                <!--Start Date-->\n                <div class="rm-ui-flex-field-div" style="margin-left:5px;">\n                    <label for="exportStartDate" class="rm-ui-flex-field-lbl">\n                        Start Date:&nbsp;\n                    </label>\n                    <div class="cpd-ui-field-div">\n                        <input type="date"\n                               placeholder="m/d/yyyy"\n                               id="exportStartDate" name="exportStartDate"\n                               data-cval-msg-element-id="ex_start_date_rcclu_vmsg"\n                               data-cval-fld-name="Start Date"\n                               [attr.data-cval-required]="_exportDateSelected"\n                               [attr.data-cval-date]="true"\n                               style="width:140px;"\n                               aria-label="Start date (format m/d/yyyy)"\n                               (input)="_exportDateChanged(\'popExportRCCLU_body\', \'exportStartDate\')"\n                               class="cval form-control"\n                               (ngModelChange)="_exportStartDate=$event; _exportDateChanged(\'popExportRCCLU_body\', \'exportStartDate\')" />\n\n                    </div>\n                </div>\n\n                <!--Spacer-->\n                <div style="width:20px;"></div>\n\n                <!--End Date-->\n                <div class="rm-ui-flex-field-div" style="flex-grow:1;">\n                    <label for="exportEndDate" class="rm-ui-flex-field-lbl">End Date:&nbsp;</label>\n                    <div class="cpd-ui-field-div">\n                        <input type="date"\n                               placeholder="m/d/yyyy"\n                               id="exportEndDate" name="exportEndDate"\n                               data-cval-msg-element-id="ex_end_date_rcclu_vmsg"\n                               data-cval-fld-name="End Date"\n                               [attr.data-cval-required]="_exportDateSelected"\n                               [attr.data-cval-date]="true"\n                               style="width:140px;"\n                               aria-label="End date (format m/d/yyyy)"\n                               (input)="_exportDateChanged(\'popExportRCCLU_body\', \'exportEndDate\')"\n                               class="cval form-control"\n                               (ngModelChange)="_exportEndDate=$event; _exportDateChanged(\'popExportRCCLU_body\', \'exportEndDate\')" />\n                    </div>\n                </div>\n            </div>\n            <div>\n\n                <!--Concern Start Date validation message-->\n                <div id="ex_start_date_rcclu_vmsg" class="cval-validation-message" style="padding-left:10px;"></div>\n                <!--Concern End Date validation message-->\n                <div id="ex_end_date_rcclu_vmsg" class="cval-validation-message" style="padding-left:10px;"></div>\n\n            </div>\n\n            <!--Resource Category-->\n            <div class="cpd-ui-field-div" style="margin:10px 0 10px 5px;">\n                <label for="popupExportRCCLU_selResourceConcernCategory" style="width:170px; text-align:left;" class="cpd-ui-field-div-lbl">Resource Concern Category:</label>\n                <select id="popupExportRCCLU_selResourceConcernCategory" style="max-width:255px;" (change)="ddl_exportCategory_changed()" [(ngModel)]="_selectedConcernCategory_concernView">\n                    <option *ngFor="let category of _concernCategories_concernView;" [ngValue]="category">{{category.resource_concern_category_display}}</option>\n                </select>\n\n            </div>\n\n            <!--Resource Concern-->\n            <div class="cpd-ui-field-div" style="margin:10px 0 10px 5px;">\n                <label for="popupExportRCCLU_selResourceConcern" style="width:170px; text-align:left;" class="cpd-ui-field-div-lbl">Resource Concern:</label>\n                <label *ngIf="_exportShowConcernLabel" style="width:255px; text-align:left; font-style:italic;">{{_exportConcernLabelText}}</label>\n                <select *ngIf="!_exportShowConcernLabel" id="popupExportRCCLU_selResourceConcern" style="max-width:255px; min-width:255px;" (change)="ddl_exportConcern_changed();" [(ngModel)]="_selectedResourceConcerns_exportRCCLUPopup">\n                    <option *ngFor="let concern of _resourceConcerns_exportRCCLUPopup;" [ngValue]="concern">{{concern.resource_concern_display}}</option>\n                </select>\n            </div>\n\n            <!--Resource Component-->\n            <div class="cpd-ui-field-div" style="margin:10px 0 10px 5px;">\n                <label for="popupExportRCCLU_selResourceConcernComponent" style="width:170px; text-align:left;" class="cpd-ui-field-div-lbl">Resource Concern Component:</label>\n                <label *ngIf="_exportShowComponentLabel" style="width:255px; text-align:left; font-style:italic;">{{_exportComponentLabelText}}</label>\n                <select *ngIf="!_exportShowComponentLabel" id="popupExportRCCLU_selResourceConcernComponent" style="max-width:255px; min-width:255px;" (change)="_popupDirty=true;" [(ngModel)]="_selectedConcernComponents_exportRCCLUPopup">\n                    <option *ngFor="let component of _concernComponents_exportRCCLUPopup;" [ngValue]="component">{{component.resource_concern_component_display}}</option>\n                </select>\n            </div>\n\n            <!--Land Use-->\n            <div class="cpd-ui-field-div" style="margin:10px 0 10px 5px;">\n                <label for="popupExportRCCLU_selLandUse" style="width:170px; text-align:left;" class="cpd-ui-field-div-lbl">Land Use:</label>\n                <select id="popupExportRCCLU_selLandUse" style="max-width:255px; min-width:255px;" (change)="_popupDirty=true;" [(ngModel)]="_selectedLandUses_exportRCCLUPopup">\n                    <option *ngFor="let landUse of _landUses_exportRCCLUPopup;" [ngValue]="landUse">{{landUse.land_use_display}}</option>\n                </select>\n            </div>\n\n        </section>\n\n        <!-- footer -->\n        <footer>\n            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>\n            <button type="button" class="btn btn-primary" (click)="exportResourceConcernComponentLandUses()">Export</button>\n        </footer>\n\n    </modal>\n\n    <!--========================================-->\n    <!-- Export RCRCC Popup -->\n    <!--========================================-->\n    <modal #popExportRCRCC\n           containerId="resource_management_page_popups"\n           title="Resource Concern to Resource Concern Component"\n           label="popExportRCRCC"\n           customClass="rm-ui-popup-export">\n\n\n        <!--FVT-ID-->\n        <section name="fvt_id" style="visibility:hidden;" data-test-id="dialog_resource_management_export_rcrcc"></section>\n\n        <!-- body -->\n        <section>\n\n            <!--For 508-->\n            <div style="position:relative; top:-8px; left:5px; font-style:italic;">All fields are optional. If date is selected, must select both dates<br /></div>\n\n            <!--Resource Concern - Dates Block-->\n            <div class="rm-ui-dates-block">\n\n                <!--Start Date-->\n                <div class="rm-ui-flex-field-div" style="margin-left:5px;">\n                    <label for="exportStartDateRCRCC" class="rm-ui-flex-field-lbl">\n                        Start Date:&nbsp;\n                    </label>\n                    <div class="cpd-ui-field-div">\n                        <input type="date"\n                               placeholder="m/d/yyyy"\n                               id="exportStartDateRCRCC" name="exportStartDateRCRCC"\n                               data-cval-msg-element-id="ex_start_date_rcrcc_vmsg"\n                               data-cval-fld-name="Start Date"\n                               [attr.data-cval-required]="_exportDateSelectedRCRCC"\n                               [attr.data-cval-date]="true"\n                               style="width:140px;"\n                               aria-label="Start date (format m/d/yyyy)"\n                               (input)="_exportDateChangedRCRCC(\'popExportRCRCC_body\', \'exportStartDate\')"\n                               class="cval form-control"\n                               (ngModelChange)="_exportStartDateRCRCC=$event; _exportDateChangedRCRCC(\'popExportRCRCC_body\', \'exportStartDate\')" />\n\n                    </div>\n                </div>\n\n                <!--Spacer-->\n                <div style="width:20px;"></div>\n\n                <!--End Date-->\n                <div class="rm-ui-flex-field-div" style="flex-grow:1;">\n                    <label for="exportEndDateRCRCC" class="rm-ui-flex-field-lbl">End Date:&nbsp;</label>\n                    <div class="cpd-ui-field-div">\n                        <input type="date"\n                               placeholder="m/d/yyyy"\n                               id="exportEndDateRCRCC" name="exportEndDateRCRCC"\n                               data-cval-msg-element-id="ex_end_date_rcrcc_vmsg"\n                               data-cval-fld-name="End Date"\n                               [attr.data-cval-required]="_exportDateSelectedRCRCC"\n                               [attr.data-cval-date]="true"\n                               style="width:140px;"\n                               aria-label="End date (format m/d/yyyy)"\n                               (input)="_exportDateChangedRCRCC(\'popExportRCRCC_body\', \'exportEndDate\')"\n                               class="cval form-control"\n                               (ngModelChange)="_exportEndDateRCRCC=$event; _exportDateChangedRCRCC(\'popExportRCRCC_body\', \'exportEndDate\')" />\n                    </div>\n                </div>\n            </div>\n            <div>\n\n                <!--Concern Start Date validation message-->\n                <div id="ex_start_date_rcrcc_vmsg" class="cval-validation-message" style="padding-left:10px;"></div>\n                <!--Concern End Date validation message-->\n                <div id="ex_end_date_rcrcc_vmsg" class="cval-validation-message" style="padding-left:10px;"></div>\n\n            </div>\n\n            <!--Resource Category-->\n            <div class="cpd-ui-field-div" style="margin:10px 0 10px 5px;">\n                <label for="popupExportRCRCC_selResourceConcernCategory" style="width:170px; text-align:left;" class="cpd-ui-field-div-lbl">Resource Concern Category:</label>\n                <select id="popupExportRCRCC_selResourceConcernCategory" style="max-width:255px;" (change)="ddl_exportCategoryRCRCC_changed()" [(ngModel)]="_selectedConcernCategory_concernView">\n                    <option *ngFor="let category of _concernCategories_concernView;" [ngValue]="category">{{category.resource_concern_category_display}}</option>\n                </select>\n\n            </div>\n\n            <!--Resource Concern-->\n            <div class="cpd-ui-field-div" style="margin:10px 0 10px 5px;">\n                <label for="popupExportRCRCC_selResourceConcern" style="width:170px; text-align:left;" class="cpd-ui-field-div-lbl">Resource Concern:</label>\n                <label *ngIf="_exportShowConcernLabelRCRCC" style="width:255px; text-align:left; font-style:italic;">{{_exportConcernLabelTextRCRCC}}</label>\n                <select *ngIf="!_exportShowConcernLabelRCRCC" id="popupExportRCRCC_selResourceConcern" style="max-width:255px; min-width:255px;" (change)="ddl_exportConcernRCRCC_changed();" [(ngModel)]="_selectedResourceConcerns_exportRCRCCPopup">\n                    <option *ngFor="let concern of _resourceConcerns_exportRCRCCPopup;" [ngValue]="concern">{{concern.resource_concern_display}}</option>\n                </select>\n            </div>\n\n            <!--Resource Component-->\n            <div class="cpd-ui-field-div" style="margin:10px 0 10px 5px;">\n                <label for="popupExportRCRCC_selResourceConcernComponent" style="width:170px; text-align:left;" class="cpd-ui-field-div-lbl">Resource Concern Component:</label>\n                <label *ngIf="_exportShowComponentLabelRCRCC" style="width:255px; text-align:left; font-style:italic;">{{_exportComponentLabelTextRCRCC}}</label>\n                <select *ngIf="!_exportShowComponentLabelRCRCC" id="popupExportRCRCC_selResourceConcernComponent" style="max-width:255px; min-width:255px;" (change)="_popupDirty=true;" [(ngModel)]="_selectedConcernComponents_exportRCRCCPopup">\n                    <option *ngFor="let component of _concernComponents_exportRCRCCPopup;" [ngValue]="component">{{component.resource_concern_component_display}}</option>\n                </select>\n            </div>\n\n        </section>\n\n        <!-- footer -->\n        <footer>\n            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>\n            <button type="button" class="btn btn-primary" (click)="exportResourceConcernResourceConcernComponent()">Export</button>\n        </footer>\n\n    </modal>\n\n</div>\n\n\n\n\n<!--[attr.readonly]="true : null"-->',
    styles : ['.rcm-main-content-div{position:absolute;top:0;right:0;bottom:0;left:0px;display:flex;flex-direction:column;min-width:450px}.rcm-control-div{flex-grow:0;display:flex;flex-wrap:wrap;align-items:center;margin:0px 8px 8px 8px;padding:2px 0 2px 20px;background-color:#eee;border:solid 1px #b8b8b8;border-radius:4px}.rcm-control-div-alt-1{flex-grow:0;display:flex;flex-wrap:wrap;align-items:center;margin:0px 8px 8px 8px;padding:2px 0 2px 20px;background-color:#eef;border:solid 1px #b8b8b8;border-radius:4px}.rcm-control-div-alt-2{display:flex;align-items:center;margin:0px 0 8px 8px;padding-left:20px;font-size:12px}.rcm-land_use-control-div{flex-grow:0;display:flex;flex-wrap:wrap;align-items:center;margin:0 8px 10px 8px;padding:0 8px;background-color:#eee;border:solid 1px #ddd;border-radius:4px}.rcm-filter-radio{padding-left:10px;display:flex;align-items:center}.rcm-resource-grid-div{flex-grow:1;position:relative;margin-top:15px;border-top:solid 1px #b8b8b8}.rm-ui-field{width:90%;margin-left:10px;color:#666}.rm-ui-field-div{margin:0 0 15px 0}.rm-ui-flex-field-div{margin:0 0 0 0;display:flex;align-items:center}.rm-ui-flex-field-lbl{white-space:nowrap;flex-wrap:nowrap;margin-right:0px}.rm-ui-dates-block{display:flex}.rm-ui-checks-block{display:flex}.rm-ui-popup-edit-resource{width:625px;max-width:625px}.rm-ui-popup-export{width:500px;max-width:500px}.rm-cssClasses_Grid{border-bottom:none !important}.rm-cssClasses_ColumnHeaderRow{height:10px;font-size:1px;font-weight:normal !important;box-shadow:none !important;border-top:none !important;text-align:left;width:180px;padding:0}.rm-cssClasses_Body{border:solid 1px #b8b8b8;border-radius:2px;background-color:#f0f0f0}.rm-cssClasses_Cell{padding:0 2px !important}'],
    providers: [],
    encapsulation: ViewEncapsulation.None //Allows child components to read the parent's styles
})
export class ResourceManagementComponent implements OnDestroy, OnInit {


    // INPUTS/OUTPUTS/COMPONENTS
    //-------------------------------------------------------------------------------------------------------------------------
    @ViewChild('categoryGrid') categoryGrid;
    @ViewChild('concernGrid') concernGrid;
    @ViewChild('componentGrid') componentGrid;

    @ViewChild('popCategory') popCategory;
    @ViewChild('popComponent') popComponent;
    @ViewChild('popConcern') popConcern;
    @ViewChild('popExportRCCLU') popExportRCCLU;
    @ViewChild('popExportRCRCC') popExportRCRCC;

    @ViewChild('fv_pop_rccat_start_date') fv_pop_rccat_start_date;
    @ViewChild('fv_pop_rccat_end_date') fv_pop_rccat_end_date;
    @ViewChild('fv_pop_rcc_start_date') fv_pop_rcc_start_date;
    @ViewChild('fv_pop_rcc_end_date') fv_pop_rcc_end_date;
    @ViewChild('fv_pop_rc_start_date') fv_pop_rc_start_date;
    @ViewChild('fv_pop_rc_end_date') fv_pop_rc_end_date;

    //Class wide member reference for the growls control
    growlBox = null;


    // PRIVATE MEMBERS
    //-------------------------------------------------------------------------------------------------------------------------
    //Boilerplate Vars
    _appConfig = appConfig;
    _authToken = authToken;
    _componentName = 'resourceManagement.js';
    _disposalFunctions = []; //For disposing subscriptions to rxjs observables
    _formName = 'resource_concern_management'; //Just a shortcut (also helpful for cut & paste)
    //_formData; // { forms:[], actions:[], fields:{} }; from formData2 service
    _pageLoading = true;
    _sessionStorageObject = null;
    _title = "National - Resource Concern Management - Categories";
    _today = new Date().toISOString().substring(0, 10);

    //Page management
    _currentView = "categories"; //Which list is displayed (categories, concerns, components)

    // Lists
    //------------
    // All persisted lists apply to drop down controls, as the grid data is
    // stored on the grid (settings.rows)

    // All "selected" item variables refer to DDLs on view pages as popups
    // store that om the _popupTempModels object

    //fiscal Years (applies to all views)
    _fiscalYears = []; //encompasses the range of fiscal years for all the views
    _selectedFiscalYear = null;

    //swapa categories
    _swapaCategories_concernView = [{ swapa_category_id: -1, swapa_category_name: "" }];
    _swapaCategories_concernPopup = [];
    _selectedSwapaCategory_concernView = this._swapaCategories_concernView[0];

    //resource concern categories
    _concernCategories_concernView = [{ resource_concern_category_id: -1, resource_concern_category_name: "", resource_concern_category_display: "" }];
    _concernCategories_concernPopup_new = [];
    _concernCategories_concernPopup_edit = [];
    _selectedConcernCategory_concernView = this._concernCategories_concernView[0];

    //resource concerns
    _resourceConcerns_componentView = [{ resource_concern_id: -1, resource_concern_name: "", resource_concern_display: "" }];
    _resourceConcerns_componentPopup_new = [];
    _resourceConcerns_componentPopup_edit = [];
    _selectedResourceConcern_componentView = this._resourceConcerns_componentView[0];

    //export RCCLUs
    _resourceConcerns_exportRCCLUPopup = [];
    _concernComponents_exportRCCLUPopup = [];
    _landUses_exportRCCLUPopup = [];
    _selectedResourceConcerns_exportRCCLUPopup = this._resourceConcerns_exportRCCLUPopup[0];
    _selectedConcernComponents_exportRCCLUPopup = this._concernComponents_exportRCCLUPopup[0];
    _selectedLandUses_exportRCCLUPopup = this._landUses_exportRCCLUPopup[0];
    _exportCategorySelected = false;
    _exportConcernSelected = false;
    _exportDateSelected = false;
    _exportStartDate = null;
    _exportEndDate = null;
    _exportShowConcernLabel = true;
    _exportConcernLabelText = "Select Resource Concern Category";
    _exportShowComponentLabel = true;
    _exportComponentLabelText = "Select Resource Concern";

    //export RCRCCs
    _resourceConcerns_exportRCRCCPopup = [];
    _concernComponents_exportRCRCCPopup = [];
    _selectedResourceConcerns_exportRCRCCPopup = this._resourceConcerns_exportRCRCCPopup[0];
    _selectedConcernComponents_exportRCRCCPopup = this._concernComponents_exportRCRCCPopup[0];
    _exportCategorySelectedRCRCC = false;
    _exportConcernSelectedRCRCC = false;
    _exportDateSelectedRCRCC = false;
    _exportStartDateRCRCC = null;
    _exportEndDateRCRCC = null;
    _exportShowConcernLabelRCRCC = true;
    _exportConcernLabelTextRCRCC = "Select Resource Concern Category";
    _exportShowComponentLabelRCRCC = true;
    _exportComponentLabelTextRCRCC = "Select Resource Concern";

    // Popups
    //--------
    _popupMode = "new"; //[new, edit]
    _popupDirty = false;
    _popupValid = true;

    //Temporarily holds objects used to represent what is being viewed/edited in a popup
    _popupTempModels = {

        category: {
            categoryId: null,
            categoryName: "",
            categoryDisplay: "",
            categoryStartDate: "",
            categoryEndDate: "",
            categoryPublish: false,
            categoryPublishOriginal: false //Stores value prior to any user changes, for managing "unpublishable" state
        },

        concern: {
            concernId: null,
            concernCategoryId: null,
            concernSwapaCategoryId: null,
            concernMeasurementUnitId: null,
            concernName: "",
            concernDisplay: "",
            concernDescription: "",
            concernObjective: "",
            concernThresholdRequired: false,
            concernUnitsRequired: false,
            concernStartDate: "",
            concernEndDate: "",
            concernPublish: false,
            concernPublishOriginal: false //Stores value prior to any user changes, for managing "unpublishable" state
        },

        component: {
            componentId: null,
            componentConcernId: null,
            componentMeasurementUnitId: null,
            componentName: "",
            componentDisplay: "",
            componentDesription: "",
            componentObjective: "",
            componentStartDate: "",
            componentEndDate: "",
            componentPublish: false,
            componentPublishOriginal: false //Stores value prior to any user changes, for managing "unpublishable" state
        }
    }

    //Grids
    //--------
    _categoryGridSettings = {
        //defaultFilter: (row) => { return row.resource_concern_category_id != -1; },
        defaultFilters: { default: ((row) => { return row.resource_concern_category_id != -1; }) },
        hideClearSelectedButton: true,
        loading: false,
        positionAbsolute: true,
        rowIdentifyForJAWS: true,
        rowIdentityFieldForJAWS: "resource_concern_category_name",
        rowIdentityPrefixForJAWS: "Resource Concern Category",
        columns: [
            { fieldName: 'resource_concern_category_name', display: 'Category Name', width: '35%', minWidth: 75 },
            { fieldName: 'resource_concern_category_display', display: 'Category Display', width: '35%', minWidth: 75 },
            { fieldName: 'start_date', display: 'Start Date', width: '10%', minWidth: 50, procDataFn: (val) => { return this.cpdFormatters.formatDateString(val) }, dataType: 'date' },
            { fieldName: 'end_date', display: 'End Date', width: '10%', minWidth: 50, procDataFn: (val) => { return this.cpdFormatters.formatDateString(val) }, dataType: 'date' },
            { fieldName: 'publish', display: 'Publish', width: '10%', minWidth: 30 },
        ],
        rows: []
    };

    _concernGridSettings = {
        hideClearSelectedButton: true,
        loading: false,
        positionAbsolute: true,
        rowIdentifyForJAWS: true,
        rowIdentityFieldForJAWS: "resource_concern_name",
        rowIdentityPrefixForJAWS: "Resource Concern Name",
        columns: [
            { fieldName: 'swapa_category_display', display: 'SWAPAE+H Category', width: '12%', minWidth: 75 },
            { fieldName: 'resource_concern_category_display', display: 'Concern Category', width: '18%', minWidth: 75 },
            { fieldName: 'resource_concern_name', display: 'Concern Name', width: '23%', minWidth: 75 },
            { fieldName: 'resource_concern_display', display: 'Concern Display', width: '23%', minWidth: 75 },
            { fieldName: 'start_date', display: 'Start Date', width: '8%', minWidth: 50, procDataFn: (val) => { return this.cpdFormatters.formatDateString(val) } },
            { fieldName: 'end_date', display: 'End Date', width: '8%', minWidth: 50, procDataFn: (val) => { return this.cpdFormatters.formatDateString(val) } },
            { fieldName: 'publish', display: 'Publish', width: '8%', minWidth: 30 },
        ],
        rows: []
    };

    _componentGridSettings = {
        hideClearSelectedButton: true,
        loading: false,
        positionAbsolute: true,
        rowIdentifyForJAWS: true,
        rowIdentityFieldForJAWS: "resource_concern_component_name",
        rowIdentityPrefixForJAWS: "Resource Concern Name",
        columns: [
            { fieldName: 'resource_concern_display', display: 'Resource Concern', width: '23%', minWidth: 75 },
            { fieldName: 'resource_concern_component_name', display: 'Component Name', width: '23%', minWidth: 75 },
            { fieldName: 'resource_concern_component_display', display: 'Component Display', width: '30%', minWidth: 75 },
            { fieldName: 'resource_concern_component_start_date', display: 'Start Date', width: '8%', minWidth: 50, procDataFn: (val) => { return this.cpdFormatters.formatDateString(val) } },
            { fieldName: 'resource_concern_component_end_date', display: 'End Date', width: '8%', minWidth: 50, procDataFn: (val) => { return this.cpdFormatters.formatDateString(val) } },
            { fieldName: 'resource_concern_component_publish', display: 'Publish', width: '8%', minWidth: 30 },
        ],
        rows: []
    };

    _pageUrl = '';


    // INITIALIZATION
    //-------------------------------------------------------------------------------------------------------------------------
    //=======================================
    // constructor
    //=======================================
    constructor(casNavBoxService: CASNavBoxService,
        cpdFormatters: CPDFormatters,
        //formDataService: FormDataService2,
        helpers: Helpers,
        router: Router,
        webServices: WebServices,
        featureFlagService: FeatureFlagService) {

        this.constructor.mapParams(this, arguments);

        this._pageURL = this.router.url;

        //Init local storage
        this._sessionStorageObject = this._loadSessionStorageObject();
        if (!this._sessionStorageObject) {

            this._sessionStorageObject = {
                selectedComponent: null,
                fy: null,
                currentView: "categories"
            }
            this._saveSessionStorageObject(this._sessionStorageObject);
        }
        else {
            this._currentView = this._sessionStorageObject.currentView;
            var currentViewUpper = this._currentView.replace(/(^|\s)\S/g, function (t) { return t.toUpperCase() });
            this._title = "National - Resource Concern Management - " + currentViewUpper;
        }

        //Handle clicks on the NavBox actions via the navBoxCommService
        var disposer = casNavBoxService.OnActionClicked$.subscribe(action => {
            this.navBoxActionClicked(action);
        });
        this._disposalFunctions.push(disposer);

        // Validation
        //--------------
        this.casValidate = new CASValidate(this);

        // Debugging 
        //--------------
        casNavBoxService.ClearDebugEntries();
        casNavBoxService.DebugEntries.push("Hide", "Unhide", "Test");

        disposer = casNavBoxService.OnDebugEntryClicked$.subscribe(entry => {
            this.debugEntryClicked(entry);
        });
        this._disposalFunctions.push(disposer);
    };

    //=======================================
    // ngOnDestroy
    //=======================================
    ngOnDestroy() {
        for (var i = 0; i < this._disposalFunctions.length; i++) {
            this._disposalFunctions[i].unsubscribe();
        }
    };

    //=======================================
    // ngOnInit
    //=======================================
    ngOnInit() {
        console.log("\n[{0}:ngOnInit()]------------------------------------------------------------------------".format(this._componentName));
        this.initalizeGrowlBox();
        this.loadPageValues();
    };

    //========================================
    // Load Page Values
    //========================================
    loadPageValues() {
        //Number of async ops this function has left to complete
        var ops = 6;

        //Prep initial filter values
        let curFY = this.helpers.getFY();
        let swapaCategoryId = null;
        let resourceConcernCategoryId = null;

        //508
        window.setTimeout(() => {
            document.getElementById("accAlertAssertive").innerText = "Loading page data";
            let el = document.getElementsByClassName("cpd-title-div")[0];
            if (el) { el.focus(); }
        }, 0);

        this.casNavBoxService.ActionsLoading = true;

        //Grab the fiscal year range
        this.initFiscalYears(() => {
            if (--ops == 0) { this.ngOnInit_Complete(); }
        });

        //Init resource concern category lists
        this.initResourceConcernCategoryLists(null, () => {
            if (--ops == 0) { this.ngOnInit_Complete(); }
        });

        this.initResourceConcernLists(null, null, () => {
            if (--ops == 0) { this.ngOnInit_Complete(); }
        });

        this.initResourceConcernComponentLists(null, () => {
            if (--ops == 0) { this.ngOnInit_Complete(); }
        })

        this.initSwapaLists(null, () => {
            if (--ops == 0) { this.ngOnInit_Complete(); }
        });

        // Load action links
        this.loadActionLinks(() => {
            if (--ops == 0) { this.ngOnInit_Complete(); }
        });
    }

    //========================================
    // initalizeGrowlBox
    //========================================
    initalizeGrowlBox() {
        this.growlBox = new BCGrowls("growlBox");
        this.growlBox.init({
            appendToElementId: "cpdesGrowlContainer" //cpdesGrowlContainer defined in \Nrcs.Cpdes.Ui\src\cpdes\components\cpdes.html
        });
    }

    //=======================================
    // ngOnInit_Complete
    //=======================================
    // Called once all the async work in onInit is complete
    ngOnInit_Complete() {

        //Init the validation class
        this.casValidate.initialize(true);

        this._pageLoading = false;
    };

    // SERVICE - EVENT HANDLERS
    //-------------------------------------------------------------------------------------------------------------------------
    //=======================================
    // navBoxActionClicked
    //=======================================
    navBoxActionClicked(action) {

        console.log("[{0}:navBoxActionClicked()] - action:".replace([0], this._componentName), action);

        switch (action.field_name) {

            //New Resource Concern
            case "act_new_resource_concern":

                //Make sure the selected FY isn't so old there is no swapa data (which is currently required in the UI)
                //(we need to revwork this module with business as I don't think it's working ideally)
                if (!this._swapaCategories_concernPopup || this._swapaCategories_concernPopup.length == 0) {
                    this.growlBox.addGrowl("error", "The selected fiscal year does not have any SWAPA data and cannot be used to create a new Concern");
                    return;
                }
                this.action_newResourceConcern();
                break;

            //Revise Resource Concern
            case "act_revise_resource_concern":
                this.action_reviseResourceConcern();
                break;

            //New Resource Concern Category
            case "act_new_resource_concern_category":
                this.action_newResourceConcernCategory();
                break;

            //Revise Resource Concern Category
            case "act_revise_resource_concern_category":
                this.action_reviseResourceConcernCategory();
                break;

            //New Resource Component
            case "act_new_resource_concern_component":
                this.action_newResourceConcernComponent();
                break;

            //Revise Resource Component
            case "act_revise_resource_concern_component":
                this.action_reviseResourceConcernComponent();
                break;

            //Land Uses
            case "act_land_use":
                this.action_landUse();
                break;

            //RCC-LU Export
            case "act_export_resource_concern_component_land_use":
                this.action_exportResourceConcernComponentLandUse();
                break;

            //RC-RCC Export
            case "act_export_resource_concern_resource_concern_component":
                this.action_exportResourceConcernResourceConcernComponent();
                break;
        }
    };



    //==================================
    // _formChanged
    //==================================
    _formChanged(modelName, event) {
        //Mark the form dirty if it isn't already
        if (!this._popupDirty) {
            this._popupDirty = true;
        }

        //Check the popup's validity
        let isValid = this.casValidate.isAllValid(true, modelName);
        if (isValid) {
            this._popupValid = true;
        }
        else {
            //Form is invalid
            this._popupValid = false;
        }
    };

    //==================================
    // _exportDateChanged
    //==================================
    _exportDateChanged(modelName, controlName, event) {

        this._exportDateSelected = true;
        let elStartDate = document.getElementById("exportStartDate");
        let elEndDate = document.getElementById("exportEndDate");

        this._exportStartDate = elStartDate.value ? elStartDate.value : "";
        this._exportEndDate = elEndDate.value ? elEndDate.value : "";

        if (controlName == "exportStartDate") {
            elEndDate.setAttribute("data-cval-required", "true");
        }

        if (controlName == "exportEndDate") {
            elStartDate.setAttribute("data-cval-required", "true");
        }

        if (this._exportEndDate == "" && this._exportStartDate == "") {
            elEndDate.setAttribute("data-cval-required", false);
            elStartDate.setAttribute("data-cval-required", false);
        }

        this._formChanged(modelName, event);
    };

    //==================================
    // _exportDateChangedRCRCC
    //==================================
    _exportDateChangedRCRCC(modelName, controlName, event) {

        this._exportDateSelectedRCRCC = true;
        let elStartDate = document.getElementById("exportStartDateRCRCC");
        let elEndDate = document.getElementById("exportEndDateRCRCC");

        this._exportStartDateRCRCC = elStartDate.value ? elStartDate.value : "";
        this._exportEndDateRCRCC = elEndDate.value ? elEndDate.value : "";

        if (controlName == "exportStartDate") {
            elEndDate.setAttribute("data-cval-required", "true");
        }

        if (controlName == "exportEndDate") {
            elStartDate.setAttribute("data-cval-required", "true");
        }

        if (this._exportEndDateRCRCC == "" && this._exportStartDateRCRCC == "") {
            elEndDate.setAttribute("data-cval-required", false);
            elStartDate.setAttribute("data-cval-required", false);
        }

        this._formChanged(modelName, event);
    };


    // EVENT HANDLERS & BL
    //-------------------------------------------------------------------------------------------------------------------------

    loadActionLinks(fnOnComplete) {
        // Load the form fields
        //-----------------------------------

        let actions = [];

        switch (authToken.user.role) {
            case Enums.Roles.NHQNationalPracticeDataSteward.id:
                actions.push(new FormAction("act_new_resource_concern_category", "New Category"));
                actions.push(new FormAction("act_revise_resource_concern_category", "Edit Category"));
                actions.push(new FormAction("act_new_resource_concern", "New Resource"));
                actions.push(new FormAction("act_revise_resource_concern", "Edit Resource"));
                actions.push(new FormAction("act_new_resource_concern_component", "New Component"));
                actions.push(new FormAction("act_revise_resource_concern_component", "Edit Component"));
                actions.push(new FormAction("act_land_use", "Land Uses", true, "Associate Land Uses to Resource Concern Component"));
                actions.push(new FormAction("act_export_resource_concern_resource_concern_component", "RC-RCC Export", true, "Resource Concern to Resource Concern Component Association Export"));
                actions.push(new FormAction("act_export_resource_concern_component_land_use", "RCC-LU Export", true, "Resource Concern Component to Land Use Association Export"));
                
                console.log("[{0}:ngOnInit()] - actionLinks:".format(this._componentName, this._formName), actions);

                //Hide the actions that will not be visible on the default view
                actions.forEach((action) => {

                    switch (this._currentView) {
                        case "categories":
                            switch (action.field_name) {
                                //Leave these visible (default first view: resource concern categories)
                                case "act_revise_resource_concern_category":
                                case "act_new_resource_concern_category":
                                case "act_export_resource_concern_resource_concern_component":
                                case "act_export_resource_concern_component_land_use":
                                    break;

                                //Hide everything else
                                default:
                                    this.casNavBoxService.HideAction(action);
                            }
                            break;

                        case "concerns":
                            switch (action.field_name) {
                                case "act_new_resource_concern":
                                case "act_revise_resource_concern":
                                case "act_export_resource_concern_resource_concern_component":
                                case "act_export_resource_concern_component_land_use":
                                    break;

                                default:
                                    this.casNavBoxService.HideAction(action);
                            }
                            break;

                        case "components":
                            switch (action.field_name) {
                                case "act_new_resource_concern_component":
                                case "act_revise_resource_concern_component":
                                case "act_land_use":
                                case "act_export_resource_concern_resource_concern_component":
                                case "act_export_resource_concern_component_land_use":
                                    break;

                                default:
                                    this.casNavBoxService.HideAction(action);
                            }
                            break;

                    }
                });

                break;

            case Enums.Roles.StateDataSteward.id:
                actions.push(new FormAction("act_export_resource_concern_resource_concern_component", "RC-RCC Export", true, "Resource Concern to Resource Concern Component Association Export"));
                actions.push(new FormAction("act_export_resource_concern_component_land_use", "RCC-LU Export", true, "Resource Concern Component to Land Use Association Export"));

                break;
        }

        if (this.router.url.startsWith(this._pageURL)) {
            //Tell the shared navBoxCommService what the current actions are (will update the navBox actions)
            this.casNavBoxService.Actions = actions;
            this.casNavBoxService.ActionsLoading = false;
        }
        if (fnOnComplete) { fnOnComplete(); }

    }

    //=======================================
    // action_newResourceConcern
    //=======================================
    action_newResourceConcern() {

        //Prep the popup
        this._popupMode = "new";
        this._popupDirty = false;

        //Prep the popup model
        this._popupTempModels.concern = {
            concernId: null,
            concernCategoryId: this._concernCategories_concernPopup_new[0].resource_concern_category_id,
            //concernSwapaCategoryId: null,
            concernSwapaCategoryId: this._swapaCategories_concernPopup[0].swapa_category_id,
            concernMeasurementUnitId: null,
            concernName: "",
            concernDisplay: "",
            concernDescription: "",
            concernObjective: "",
            concernThresholdRequired: false,
            concernUnitsRequired: false,
            concernStartDate: "",
            concernEndDate: "",
            concernPublish: false,
            concernPublishOriginal: false
        };

        //Supress initial validation complaints
        this.casValidate.markAllValid();

        //Oopen the popup
        this.popConcern.Open(() => {

            //Clear the validation messages
            this.casValidate.markAllValid();
        });
    }

    //=======================================
    // action_reviseResourceConcern
    //=======================================
    action_reviseResourceConcern() {

        //Make sure a row was selected
        let selectedConcern = this.concernGrid.GetFirstSelectedRow();
        if (!selectedConcern) {
            this.growlBox.addGrowl("error", "Please select a resource concern to edit.");
            return;
        }

        //Prep the popup
        this._popupMode = "edit";
        this._popupDirty = false;

        this.casValidate.markAllValid(); //Let's not start out showing errors on existing data

        //Clear the bound concern values to prevent a flicker of old values before the new ones are set
        this._popupTempModels.concern = {
            concernId: 0,
            concernCategoryId: 0,
            concernSwapaCategoryId: 0,
            concernMeasurementUnitId: 0,
            concernName: "",
            concernDisplay: "",
            concernDescription: "",
            concernObjective: "",
            concernThresholdRequired: false,
            concernUnitsRequired: false,
            concernStartDate: "",
            concernEndDate: "",
            concernPublish: false,
            concernPublishOriginal: false
        };

        //Open the dialog
        this.popConcern.Open(() => {
            //Clear the validation messages
            this.casValidate.markAllValid();
        });

        //Set the values
        //Wait a moment for Angular to finsh its render (this is an attempt to fix that intermittent problem where the inputs show values and the ngModels have those same values, but the elements have blank values.)
        window.setTimeout(() => {

            //Prep the temp object for editing
            this._popupTempModels.concern = {
                concernId: selectedConcern.resource_concern_id,
                concernCategoryId: selectedConcern.resource_concern_category_id,
                concernSwapaCategoryId: selectedConcern.swapa_category_id,
                concernMeasurementUnitId: selectedConcern.measurement_unit_id,
                concernName: selectedConcern.resource_concern_name,
                concernDisplay: selectedConcern.resource_concern_display,
                concernDescription: selectedConcern.resource_concern_description,
                concernObjective: selectedConcern.resource_concern_objective,
                concernThresholdRequired: this.helpers.stringToBoolean(selectedConcern.threshold_required_ind),
                concernUnitsRequired: this.helpers.stringToBoolean(selectedConcern.units_required_ind),
                concernStartDate: selectedConcern.start_date ? new Date(selectedConcern.start_date).toISOString().substring(0, 10) : null,
                concernEndDate: selectedConcern.end_date ? new Date(selectedConcern.end_date).toISOString().substring(0, 10) : null,
                concernPublish: this.helpers.stringToBoolean(selectedConcern.publish),
                concernPublishOriginal: this.helpers.stringToBoolean(selectedConcern.publish)
            };

        }, 0);

    }

    //=======================================
    // action_newResourceConcernCategory
    //=======================================
    action_newResourceConcernCategory() {

        //Prep the popup
        this._popupMode = "new";
        this._popupDirty = false;

        //Prep the popup model
        this._popupTempModels.category = {
            categoryId: null,
            categoryName: "",
            categoryDisplay: "",
            categoryStartDate: "",
            categoryEndDate: "",
            categoryPublish: false,
            categoryPublishOriginal: false
        };

        //Supress initial validation complaints
        this.casValidate.markAllValid();

        //Open the popup
        this.popCategory.Open(() => {

            //Clear the validation messages
            this.casValidate.markAllValid();
        });
    }

    //=======================================
    // action_reviseResourceConcernCategory
    //=======================================
    action_reviseResourceConcernCategory() {

        //Make sure a row was selected
        let selectedCategory = this.categoryGrid.GetFirstSelectedRow();
        if (!selectedCategory) {
            this.growlBox.addGrowl("error", "Please select a resource concern category to edit.");
            return;
        }

        //Prep the popup
        this._popupMode = "edit";
        this._popupDirty = false;

        //Prep the temp object for editing
        this._popupTempModels.category = {
            categoryId: selectedCategory.resource_concern_category_id,
            categoryName: selectedCategory.resource_concern_category_name,
            categoryDisplay: selectedCategory.resource_concern_category_display,
            categoryStartDate: selectedCategory.start_date ? new Date(selectedCategory.start_date).toISOString().substring(0, 10) : null,
            categoryEndDate: selectedCategory.end_date ? new Date(selectedCategory.end_date).toISOString().substring(0, 10) : null,
            categoryPublish: this.helpers.stringToBoolean(selectedCategory.publish),
            categoryPublishOriginal: this.helpers.stringToBoolean(selectedCategory.publish)
        };

        this.casValidate.markAllValid(); //Let's not start out showing errors on existing data

        this.popCategory.Open(() => {

            //Clear the validation messages
            this.casValidate.markAllValid();
        });
    }

    //=======================================
    // action_newResourceConcernComponent
    //=======================================
    action_newResourceConcernComponent() {

        //Prep the popup
        this._popupMode = "new";
        this._popupDirty = false;

        //Prep the popup model
        this._popupTempModels.component = {
            componentId: null,
            componentConcernId: this._resourceConcerns_componentPopup_new[0].resource_concern_id,
            componentMeasurementUnitId: null,
            componentName: "",
            componentDisplay: "",
            componentDesription: "",
            componentObjective: "",
            componentStartDate: "",
            componentEndDate: "",
            componentPublish: false,
            componentPublishOriginal: false
        };

        //Supress initial validation complaints
        this.casValidate.markAllValid();

        //Oopen the popup
        this.popComponent.Open(() => {

            //Clear the validation messages
            this.casValidate.markAllValid();
        });

    }

    //=======================================
    // action_reviseResourceConcernComponent
    //=======================================
    action_reviseResourceConcernComponent() {

        //Make sure a row was selected
        let selectedComponent = this.componentGrid.GetFirstSelectedRow();
        if (!selectedComponent) {
            this.growlBox.addGrowl("error", "Please select a resource concern component to edit.");
            return;
        }

        //console.log("-----> selectedComponent:", selectedComponent);

        //Prep the popup
        this._popupMode = "edit";
        this._popupDirty = false;

        //Prep the temp object for editing
        this._popupTempModels.component = {

            componentId: selectedComponent.resource_concern_component_id,
            componentConcernId: selectedComponent.resource_concern_id,
            componentMeasurementUnitId: null,
            componentName: selectedComponent.resource_concern_component_name,
            componentDisplay: selectedComponent.resource_concern_component_display,
            componentDescription: selectedComponent.resource_concern_component_description,
            componentObjective: selectedComponent.resource_concern_component_objective,
            componentStartDate: selectedComponent.resource_concern_component_start_date ? new Date(selectedComponent.resource_concern_component_start_date).toISOString().substring(0, 10) : null,
            componentEndDate: selectedComponent.resource_concern_component_end_date ? new Date(selectedComponent.resource_concern_component_end_date).toISOString().substring(0, 10) : null,
            componentPublish: this.helpers.stringToBoolean(selectedComponent.resource_concern_component_publish),
            componentPublishOriginal: this.helpers.stringToBoolean(selectedComponent.resource_concern_component_publish)
        };

        this.casValidate.markAllValid(); //Let's not start out showing errors on existing data

        this.popComponent.Open(() => {

            //Clear the validation messages
            this.casValidate.markAllValid();
        });
    }

    //=======================================
    // action_landUse
    //=======================================
    action_landUse() {

        //Make sure a row was selected
        let selectedComponent = this.componentGrid.GetFirstSelectedRow();
        if (!selectedComponent) {
            this.growlBox.addGrowl("error", "Please select a resource concern component to edit.");
            return;
        }

        let route = "/cpdes/practices/componentLandUse/{0}/{1}".format(this._selectedFiscalYear, this.selectedComponent.resource_concern_component_id);
        this.router.navigate([route]);

    }

    //=======================================
    // action_exportResourceConcernComponentLandUse
    //=======================================
    action_exportResourceConcernComponentLandUse() {

        //Prep the popup
        this._popupDirty = false;
        this._popupValid = true;

        this._getLandUsesForExport(() => {
            this._selectedLandUses_exportRCCLUPopup = this._landUses_exportRCCLUPopup[0];
        });

        // Clear all values to start
        document.getElementById("exportStartDate").value = null;
        document.getElementById("exportEndDate").value = null;
        this._selectedConcernCategory_concernView = this._concernCategories_concernView[0];
        this._selectedResourceConcerns_exportRCCLUPopup = this._resourceConcerns_exportRCCLUPopup[0];
        this._selectedConcernComponents_exportRCCLUPopup = this._concernComponents_exportRCCLUPopup[0];
        this._exportShowConcernLabel = true;
        this._exportShowComponentLabel = true;
        this._exportConcernLabelText = "Select Resource Concern Category";
        this._exportComponentLabelText = "Select Resource Concern";
        this._exportStartDate = null;
        this._exportEndDate = null;

        this.popExportRCCLU.Open(() => {

            //Clear the validation messages
            this.casValidate.markAllValid();
        });
    }

    //=======================================
    // action_exportResourceConcernResourceConcernComponent
    //=======================================
    action_exportResourceConcernResourceConcernComponent() {

        //Prep the popup
        this._popupDirty = false;
        this._popupValid = true;

        // Clear all values to start
        document.getElementById("exportStartDateRCRCC").value = null;
        document.getElementById("exportEndDateRCRCC").value = null;
        this._selectedConcernCategory_concernView = this._concernCategories_concernView[0];
        this._selectedResourceConcerns_exportRCRCCPopup = this._resourceConcerns_exportRCRCCPopup[0];
        this._selectedConcernComponents_exportRCRCCPopup = this._concernComponents_exportRCRCCPopup[0];
        this._exportShowConcernLabelRCRCC = true;
        this._exportShowComponentLabelRCRCC = true;
        this._exportConcernLabelTextRCRCC = "Select Resource Concern Category";
        this._exportComponentLabelTextRCRCC = "Select Resource Concern";

        this.popExportRCRCC.Open(() => {

            //Clear the validation messages
            this.casValidate.markAllValid();
        });
    }

    //=======================================
    // categoryGrid_refreshClicked
    //=======================================
    categoryGrid_refreshClicked() {

        this.markCategoryGridAsLoading(true);

        let fy = this._selectedFiscalYear || this.helpers.getFY();

        this.loadResourceConcernCategories(fy, false, (dto) => {

            //Set the grid rows (check if its rendered yet)
            if (this.categoryGrid) {
                this.categoryGrid.SetRows(dto);
            }
            else {
                this._categoryGridSettings.rows = dto;
            }

            this.markCategoryGridAsLoading(false);
        });
    }

    //=======================================
    // clearAllGrids
    //=======================================
    clearAllGrids() {
        this.clearCategoryGrid();
        this.clearComponentGrid();
        this.clearConcernGrid();
    }

    //=======================================
    // clearCategoryGrid
    //=======================================
    clearCategoryGrid() {

        if (this.categoryGrid) {
            this.categoryGrid.ClearRows();
        }
        else {
            this._categoryGridSettings.rows = [];
        }
    }

    //=======================================
    // clearComponentGrid
    //=======================================
    clearComponentGrid() {

        if (this.componentGrid) {
            this.componentGrid.ClearRows();
        }
        else {
            this._componentGridSettings.rows = [];
        }
    }

    //=======================================
    // clearConcernGrid
    //=======================================
    clearConcernGrid() {

        if (this.concernGrid) {
            this.concernGrid.ClearRows();
        }
        else {
            this._concernGridSettings.rows = [];
        }
    }

    //=======================================
    // clearEndDate_category
    //=======================================
    clearEndDate_category() {
        this._popupDirty = true;
        this._popupTempModels.category.categoryEndDate = "";
    }

    //=======================================
    // clearEndDate_component
    //=======================================
    clearEndDate_component() {
        this._popupDirty = true;
        this._popupTempModels.component.componentEndDate = "";
    }

    //=======================================
    // clearEndDate_concern
    //=======================================
    clearEndDate_concern() {
        this._popupDirty = true;
        this._popupTempModels.concern.concernEndDate = "";
    }

    //=======================================
    // componentGrid_refreshClicked
    //=======================================
    componentGrid_refreshClicked() {
        this.componentView_goButtonClicked();
    }

    //=======================================
    // concernGrid_refreshClicked
    //=======================================
    concernGrid_refreshClicked() {
        this.concernView_goButtonClicked();
    }

    //=======================================
    // componentView_goButtonClicked
    //=======================================
    componentView_goButtonClicked() {

        this.markComponentGridAsLoading(true);

        let fy = this._selectedFiscalYear || this.helpers.getFY();
        let rcId = this._selectedResourceConcern_componentView.resource_concern_id;

        this.loadResourceConcernComponents(fy, rcId, false,
            (dto) => {

                if (this.componentGrid) {
                    this.componentGrid.SetRows(dto);
                }
                else {
                    this._componentGridSettings.rows = dto;
                }

                this.markComponentGridAsLoading(false);

                this._syncGridToSessionData();

            },
            (err) => {
                this._componentGridSettings.rows = [];
                this.markComponentGridAsLoading(false);
            });
    }

    //=======================================
    // concernView_goButtonClicked
    //=======================================
    concernView_goButtonClicked() {

        this.markConcernGridAsLoading(true);

        let fy = this._selectedFiscalYear || this.helpers.getFY();
        let swapaCategoryId = this._selectedSwapaCategory_concernView.swapa_category_id;
        let concernCategoryId = this._selectedConcernCategory_concernView.resource_concern_category_id;

        this.loadResourceConcerns(fy, swapaCategoryId, concernCategoryId, false,
            (dto) => {

                if (this.concernGrid) {
                    this.concernGrid.SetRows(dto);
                }
                else {
                    this._concernGridSettings.rows = dto;
                }

                this.markConcernGridAsLoading(false);
            },
            (err) => {
                this._concernGridSettings.rows = [];
                this.markConcernGridAsLoading(false);
            });
    }

    //=======================================
    // ddl_selectedFiscalYear_changed
    //=======================================
    ddl_selectedFiscalYear_changed() {

        let fy = this._selectedFiscalYear;
        //let swapaCategoryId = this._selectedSwapaCategory_concernView.swapa_category_id;
        //let resourceConcernCategoryId = this._selectedConcernCategory_concernView.resource_concern_category_id;

        //All grids are potentially invalidated by this change
        this.clearAllGrids();

        this.markCategoryGridAsLoading(true);
        this.markConcernGridAsLoading(true);
        //this.markComponentGridAsLoading(true); Add back in when components is done

        //Rerun the init methods with a specified FY to reset everything
        this.initResourceConcernCategoryLists(fy, () => { this.markCategoryGridAsLoading(false); });
        this.initResourceConcernLists(fy, null, () => { this.markConcernGridAsLoading(false); });
        this.initSwapaLists(fy);

        this._sessionStorageObject.fy = fy;
        this._saveSessionStorageObject(this._sessionStorageObject);


        ////Reload the categories view
        //this.loadResourceConcernCategoriesByFY();

        ////Reload the resource concerns ddl on the component view
        //this.loadResourceConcerns(fy, swapaCategoryId, resourceConcernCategoryId, true, (dto) => {
        //    this._resourceConcernsByFY = dto;
        //    this._ddl_selectedResourceConcern = this._resourceConcernsByFY[0];
        //});
    }

    //=======================================
    // ddl_exportCategory_changed
    //=======================================
    ddl_exportCategory_changed() {
        this._exportCategorySelected = true;
        this._exportConcernSelected = false;
        this._exportShowConcernLabel = true;
        this._exportShowComponentLabel = true;
        this._exportConcernLabelText = "Select Resource Concern Category";
        this._exportComponentLabelText = "Select Resource Concern";
        this._selectedConcernComponents_exportRCCLUPopup = this._concernComponents_exportRCCLUPopup[0];

        let nextFy = this.helpers.getFY() + 1;
        let categoryId = this._selectedConcernCategory_concernView.resource_concern_category_id;

        if (categoryId != -1) {
            this._exportConcernLabelText = "Loading...";

            this.loadResourceConcerns(nextFy, null, categoryId, true, (dto) => {
                this._resourceConcerns_exportRCCLUPopup = [{ resource_concern_id: -1, resource_concern_display: "" }].concat(dto);
                this._selectedResourceConcerns_exportRCCLUPopup = this._resourceConcerns_exportRCCLUPopup[0];
                this._exportShowConcernLabel = false;
            })
        }
    }

    //=======================================
    // ddl_exportCategoryRCRCC_changed
    //=======================================
    ddl_exportCategoryRCRCC_changed() {
        this._exportCategorySelectedRCRCC = true;
        this._exportConcernSelectedRCRCC = false;
        this._exportShowConcernLabelRCRCC = true;
        this._exportShowComponentLabelRCRCC = true;
        this._exportConcernLabelTextRCRCC = "Select Resource Concern Category";
        this._exportComponentLabelTextRCRCC = "Select Resource Concern";
        this._selectedConcernComponents_exportRCRCCPopup = this._concernComponents_exportRCRCCPopup[0];

        let nextFy = this.helpers.getFY() + 1;
        let categoryId = this._selectedConcernCategory_concernView.resource_concern_category_id;

        if (categoryId != -1) {
            this._exportConcernLabelText = "Loading...";

            this.loadResourceConcerns(nextFy, null, categoryId, true, (dto) => {
                this._resourceConcerns_exportRCRCCPopup = [{ resource_concern_id: -1, resource_concern_display: "" }].concat(dto);
                this._selectedResourceConcerns_exportRCRCCPopup = this._resourceConcerns_exportRCRCCPopup[0];
                this._exportShowConcernLabelRCRCC = false;
            })
        }
    }

    //=======================================
    // ddl_exportConcern_changed
    //=======================================
    ddl_exportConcern_changed() {
        this._exportConcernSelected = true;
        this._exportShowComponentLabel = true;
        this._exportComponentLabelText = "Select Resource Concern";

        let nextFy = this.helpers.getFY() + 1;
        let concernId = this._selectedResourceConcerns_exportRCCLUPopup.resource_concern_id;

        if (concernId != -1) {
            this._exportComponentLabelText = "Loading...";
            this.loadResourceConcernComponents(nextFy, concernId, true, (dto) => {

                this._concernComponents_exportRCCLUPopup = [{
                    resource_concern_component_id: -1, resource_concern_component_display: ""
                }].concat(dto);
                this._selectedConcernComponents_exportRCCLUPopup = this._concernComponents_exportRCCLUPopup[0];
                this._exportShowComponentLabel = false;
            });
        }

    }

    //=======================================
    // ddl_exportConcernRCRCC_changed
    //=======================================
    ddl_exportConcernRCRCC_changed() {
        this._exportConcernSelectedRCRCC = true;
        this._exportShowComponentLabelRCRCC = true;
        this._exportComponentLabelTextRCRCC = "Select Resource Concern";

        let nextFy = this.helpers.getFY() + 1;
        let concernId = this._selectedResourceConcerns_exportRCRCCPopup.resource_concern_id;

        if (concernId != -1) {
            this._exportComponentLabelTextRCRCC = "Loading...";
            this.loadResourceConcernComponents(nextFy, concernId, true, (dto) => {

                this._concernComponents_exportRCRCCPopup = [{
                    resource_concern_component_id: -1, resource_concern_component_display: ""
                }].concat(dto);
                this._selectedConcernComponents_exportRCRCCPopup = this._concernComponents_exportRCRCCPopup[0];
                this._exportShowComponentLabelRCRCC = false;
            });
        }

    }

    //=======================================
    // initFeatureFlags
    //=======================================
    // Sets Feature Flag for Resource Concern Component Land Use Export
    //This Feature Flag no longer needed
    //initFeatureFlags(fnOnComplete) {

    //    this.featureFlagService.getFeatureFlag(Enums.FeatureFlags.RCCLUExport)
    //        .then(res => {
    //            this._rcclu_export_feature_flag = res;

    //            this.featureFlagService.getFeatureFlag(Enums.FeatureFlags.RCCLUAssociationFY)
    //                .then(res2 => {
    //                    this._rcclu_association_fy_feature_flag = res2;

    //                    if (fnOnComplete) { fnOnComplete(); }
    //                })

    //        })
    //        .catch(err => {
    //            this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
    //        });

    //};

    //=======================================
    // initFiscalYears
    //======================================
    //  Loads and populates the fy list
    initFiscalYears(fnOnComplete) {

        this.webServices.Get({ apiPath: "/resource/getFiscalYearRangeForAllResources" })
            .then(res => {

                console.log("[{0}:initFiscalYears():getFiscalYearRangeForAllResources()] - res:".format(this._componentName), res);
                let dto = res.data.DTO;

                //Build FY list
                this._fiscalYears = [];
                for (let i = dto.minFiscalYear; i <= dto.maxFiscalYear; i++) {
                    this._fiscalYears.push(i);
                }

                //Select the current FY                
                this._selectedFiscalYear = this._sessionStorageObject.fy ? this._sessionStorageObject.fy : this.helpers.getFY();

                if (fnOnComplete) { fnOnComplete(); }

            })
            .catch(err => {
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
            });

    };

    //=======================================
    // initResourceConcernLists
    //=======================================
    //  fy<str>:                //(opt) Omit for Current FY
    //  noGridReload<bool>      //(opt, false) Prevents the reload from reloading the concernGrid grid.
    //
    // This method refreshes several controls that display Resource Concerns.  The concern grid however, may be
    // filtered.  If that is the case, set noGridReload to true and refresh the filtered grid separately (it's a different
    // service call, so there's no easy way to avoid two calls).
    initResourceConcernLists(fy, noGridReload, fnOnComplete) {

        let ops = 2;

        //This is the initialization so we run everything for the current fy
        fy = fy || this.helpers.getFY();
        noGridReload = noGridReload || false;

        this._resourceConcerns_componentView = [{ resource_concern_id: -1, resource_concern_name: "loading...", resource_concern_display: "loading..." }];

        //Load the concerns for Concern View Grid, the Component View DDL, and the Component Popup DDL
        this.loadResourceConcerns(fy, null, null, false, (dto) => {

            //Reload main grid?
            if (!noGridReload) {
                //Set the grid rows (check if its rendered yet)
                if (this.concernGrid) {
                    this.concernGrid.SetRows(dto);
                }
                else {
                    this._concernGridSettings.rows = dto;
                }
            }

            //Derive the concern list for the Component View DDL
            //  Same as the grid, but remove unpublished and add a blank entry (broke this out to make it easier to read)
            let blankCon = [{ resource_concern_id: -1, resource_concern_name: "", resource_concern_display: "" }];
            let publishedCons = dto.filter((con) => { return con.publish.toUpperCase() == 'Y' });
            let concatCons = blankCon.concat(publishedCons);
            this._resourceConcerns_componentView = JSON.parse(JSON.stringify(concatCons)); //Copies objects, not object refs

            //Reset the selected component
            this._selectedResourceConcern_componentView = this._resourceConcerns_componentView[0];

            //Derive the category list for Concern Popup (EDIT) DDL
            //  Same as the concern view DDL, but without the blank (i.e. fy must match selected fy)
            this._resourceConcerns_componentPopup_edit = JSON.parse(JSON.stringify(publishedCons)); //Copies objects, not object refs

            if (--ops == 0 && fnOnComplete) { fnOnComplete(); }
        });

        //Grab the next fy
        let nextFy = this.helpers.getFY() + 1;

        //Load the category list for the Concern Popup DLL (these always have to be the next fiscal year from today's date)
        this.loadResourceConcerns(nextFy, null, null, true, (dto) => {

            this._resourceConcerns_componentPopup_new = dto;
            if (--ops == 0 && fnOnComplete) { fnOnComplete(); }
        });

    }

    //=======================================
    // initResourceConcernCategoryLists
    //=======================================
    //  fy<str>:                //(opt) Omit for Current FY
    initResourceConcernCategoryLists(fy, fnOnComplete) {

        let ops = 2;

        //This is the initialization so we default everything for the current fy
        fy = fy || this.helpers.getFY();

        //Load the categories for the Category View Grid (current year, unpublished allowed)
        this.loadResourceConcernCategories(fy, false, (dto) => {

            //Set the grid rows (check if its rendered yet)
            if (this.categoryGrid) {
                this.categoryGrid.SetRows(dto);
            }
            else {
                this._categoryGridSettings.rows = dto;
            }

            //Derive the categories list for the Concern View DDL
            //  Same as the grid, but remove unpublished and add a blank entry (broke this out to make it easier to read)
            let blankCat = [{ resource_concern_category_id: -1, resource_concern_category_name: "", resource_concern_category_display: "" }];
            let publishedCats = dto.filter((cat) => { return cat.publish.toUpperCase() == 'Y' });
            let concatCats = blankCat.concat(publishedCats); //lol
            this._concernCategories_concernView = JSON.parse(JSON.stringify(concatCats)); //Copies objects, not object refs

            //Derive the category list for Concern Popup (EDIT) DDL
            //  Same as the concern view DDL, but without the blank (i.e. fy must match selected fy)
            this._concernCategories_concernPopup_edit = JSON.parse(JSON.stringify(publishedCats)); //Copies objects, not object refs

            if (--ops == 0 && fnOnComplete) { fnOnComplete(); }
        });

        //Grab the next fy
        let nextFy = this.helpers.getFY() + 1;

        //Load the category list for the Concern Popup (NEW) DDL (these always have to be the next fiscal year from today's date)
        this.loadResourceConcernCategories(nextFy, true, (dto) => {

            this._concernCategories_concernPopup_new = dto;
            if (--ops == 0 && fnOnComplete) { fnOnComplete(); }
        });
    }

    //=======================================
    // initResourceConcernComponentLists
    //=======================================
    //  fy<str>: (opt) Omit for Current FY
    initResourceConcernComponentLists(fy, fnOnComplete) {

        let ops = 1;

        //This is the initialization so we default everything for the current fy
        fy = fy || this.helpers.getFY();

        //Load the categories for the Category View Grid (current year, unpublished allowed)
        this.loadResourceConcernComponents(fy, -1, false, (dto) => {

            //Set the grid rows (check if its rendered yet)
            if (this.componentGrid) {
                this.componentGrid.SetRows(dto);
            }
            else {
                this._componentGridSettings.rows = dto;
            }

            this.markComponentGridAsLoading(false);

            this._syncGridToSessionData();

        },
            (err) => {
                this._componentGridSettings.rows = [];
                this.markComponentGridAsLoading(false);
            });

        if (--ops == 0 && fnOnComplete) { fnOnComplete(); }

    }

    //=======================================
    // initSwapaLists
    //=======================================
    //  fy<str>:                //(opt) Omit for Current FY
    initSwapaLists(fy, fnOnComplete) {

        //This is the initialization so we run everything for the current fy
        fy = fy || this.helpers.getFY();

        //Load the categories for the Category View Grid (current year, unpublished allowed)
        this.loadSwapaCategories(fy, true, (dto) => {

            //Create the Concern View DDL list with a blank entry
            this._swapaCategories_concernView = [{
                swapa_category_id: -1,
                swapa_category_name: ""
            }].concat(dto);

            //Create a copy for the Concern Popup (it could differ later on FY so it needs to be a real copy)
            //this._swapaCategories_concernPopup = JSON.parse(JSON.stringify(this._swapaCategories_concernView));
            this._swapaCategories_concernPopup = JSON.parse(JSON.stringify(dto)); //No blank entries

            if (fnOnComplete) { fnOnComplete(); }
        });
    }

    //=======================================
    // loadResourceConcerns
    //=======================================
    loadResourceConcerns(fy, swapaCategoryId, concernCategoryId, publishedOnly, fnOnComplete, fnOnError) {

        //Load the selected 
        this.webServices.Get({
            apiPath: "/resource/getResourceConcerns",
            args: {
                fiscalYear: fy,
                swapaCategoryId: swapaCategoryId == -1 ? null : swapaCategoryId,
                resourceConcernCategoryId: concernCategoryId == -1 ? null : concernCategoryId,
                publishedOnly: publishedOnly
            }
        })
            .then(res => {
                console.log("[{0}:loadResourceConcerns():getResourceConcerns()] - res:".format(this._componentName), res);
                if (fnOnComplete) { fnOnComplete(res.data.DTO); }

            })
            .catch(err => {
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
                if (fnOnError) { fnOnError(); }
            });
    }

    //=======================================
    // loadResourceConcernCategories
    //=======================================
    loadResourceConcernCategories(fy, publishedOnly, fnOnComplete, fnOnError) {

        this.webServices.Get({
            apiPath: "/resource/getResourceConcernCategories",
            args: {
                fiscalYear: fy,
                publishedOnly: publishedOnly
            }
        })
            .then(res => {
                console.log("[{0}:loadResourceConcernCategories():getResourceConcernCategories()] - res:".format(this._componentName), res);
                if (fnOnComplete) { fnOnComplete(res.data.DTO); }
            })
            .catch(err => {
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
                if (fnOnError) { fnOnError(); }
            });
    }

    //=======================================
    // loadResourceConcernComponents
    //=======================================
    loadResourceConcernComponents(fy, resourceConcernId, publishedOnly, fnOnComplete, fnOnError) {

        this.webServices
            .Get({
                apiPath: "/resource/getResourceConcernComponents2",
                args: {
                    fiscalYear: fy,
                    resourceConcernId: resourceConcernId == -1 ? null : resourceConcernId,
                    resourceConcernComponentId: null,
                    publishedOnly: publishedOnly,
                    filterLandUseByFY: false
                }
            })
            .then(res => {
                console.log("[{0}:loadResourceConcernComponents():getResourceConcernComponents()] - res:".format(this._componentName), res);
                if (fnOnComplete) { fnOnComplete(this.flattenRCC_DTO(res.data.DTO)); }

            })
            .catch(err => {
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
                if (fnOnError) { fnOnError(); }
            });
    }

    //=======================================
    // loadSwapaCategories
    //=======================================
    loadSwapaCategories(fy, publishedOnly, fnOnComplete, fnOnError) {

        this.webServices.Get({
            apiPath: "/resource/getSwapaCategories",
            args: {
                fiscalYear: fy,
                publishedOnly: publishedOnly
            }
        })
            .then(res => {
                console.log("[{0}:loadSwapaCategories():getSwapaCategories()] - res:".format(this._componentName), res);
                if (fnOnComplete) { fnOnComplete(res.data.DTO); }
            })
            .catch(err => {
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
                if (fnOnError) { fnOnError(); }
            });
    };

    //==================================
    // _loadSessionStorageObject
    //==================================
    _loadSessionStorageObject() {
        var obj = sessionStorage.getItem(this._formName);
        return obj ? JSON.parse(obj) : null;
    }

    //=======================================
    // markCategoryGridAsLoading
    //=======================================
    markCategoryGridAsLoading(isLoading) {

        if (this.categoryGrid) {
            this.categoryGrid.MarkAsLoading(isLoading);
        }
        else {
            this._categoryGridSettings.loading = isLoading;
        }
    }

    //=======================================
    // markComponentGridAsLoading
    //=======================================
    markComponentGridAsLoading(isLoading) {

        if (this.componentGrid) {
            this.componentGrid.MarkAsLoading(isLoading);
        }
        else {
            this._componentGridSettings.loading = isLoading;
        }
    }

    //=======================================
    // markConcernGridAsLoading
    //=======================================
    markConcernGridAsLoading(isLoading) {

        if (this.concernGrid) {
            this.concernGrid.MarkAsLoading(isLoading);
        }
        else {
            this._concernGridSettings.loading = isLoading;
        }
    }

    //==================================
    // onRowSelectionChanged
    //==================================
    onRowSelectionChanged() {

        if (this.componentGrid) {
            this.selectedComponent = this.componentGrid.GetFirstSelectedRow();

            if (this.selectedComponent) {
                this._sessionStorageObject.selectedComponentId = this.selectedComponent.resource_concern_component_id;
                this._saveSessionStorageObject(this._sessionStorageObject);

            }
            else {
                this._sessionStorageObject.selectedComponentId = null;
                this._saveSessionStorageObject(this._sessionStorageObject);
            }
        }
    }

    //=======================================
    // popCategory_butCopyName_clicked
    //=======================================
    popCategory_butCopyName_clicked() {
        this._popupTempModels.category.categoryDisplay = this._popupTempModels.category.categoryName;
    }

    //=======================================
    // popComponent_butCopyName_clicked 
    //=======================================
    popComponent_butCopyName_clicked() {
        this._popupTempModels.component.componentDisplay = this._popupTempModels.component.componentName;
    }

    //=======================================
    // popConcern_butCopyName_clicked
    //=======================================
    popConcern_butCopyName_clicked() {
        this._popupTempModels.concern.concernDisplay = this._popupTempModels.concern.concernName;
    }

    //==================================
    // _saveSessionStorageObject
    //==================================
    _saveSessionStorageObject(obj) {
        if (!obj) { throw "[{0}:_saveSessionStorageObject] - obj must not be empty".format(this._componentName) }
        sessionStorage.setItem(this._formName, JSON.stringify(obj));
    }

    //==================================
    // _syncGridToSessionData
    //==================================
    _syncGridToSessionData() {

        //Wrap this in an async wait in case the grid hasn't loaded yet
        this.helpers.executeOnCondition(
            () => { return !!this.componentGrid; },
            () => {

                //Check to see if a narrative is selected
                if (this._sessionStorageObject.selectedComponentId) {
                    if (!this.componentGrid.SelectRowByPayloadValue("resource_concern_component_id", this._sessionStorageObject.selectedComponentId)) {
                        //Response was false, row was not found.  Clear from the session storage
                        this._sessionStorageObject.selectedComponentId = null;
                    }
                }

            }, 50, 10
        );
    }

    //==================================
    // _syncCurrentViewTSessionData
    //==================================
    _syncCurrentViewToSessionData() {

        //Check to see if a current view is set in session
        if (this._sessionStorageObject.currentView) {
            this._currentView = this._sessionStorageObject.currentView;

        }

    }

    //==================================
    // _filterLandUses
    //==================================
    _filterLandUses(landUses) {
        //Cut out the unused land uses
        let filteredAllLandUses = landUses.filter(lu => {
            switch (lu.land_use_code.toLowerCase()) {
                case "pr":  //protected
                case "kw":  //undetermined
                    break;
                default:
                    return lu;
            }
        });
        return filteredAllLandUses;
    }

    //==================================
    // _getLandUsesForExport
    //==================================
    _getLandUsesForExport(fnOnComplete) {

        //Load the land uses from the server
        this.webServices.Get({
            apiPath: "/landuse/getLandUses",
            clone: true,
            args: {
                fy: this._selectedFiscalYear
            }
        })
            .then((res) => {
                console.log("[resourceManagement:_getLandUsesForExport():GetCached()] (/landuse/getLandUses, Default) res:", res);

                // Create land use DDL list with blank entry
                let allLandUses = [{ land_use_id: -1, land_use_code: "", land_use_name: "", land_use_display: "", land_use_description: "" }].concat(res.data.DTO);

                //Cut out the unused land uses
                this._landUses_exportRCCLUPopup = this._filterLandUses(allLandUses);
                if (fnOnComplete) { fnOnComplete(); }

            });
    }

    //=======================================
    // exportResourceConcernComponentLandUses
    //=======================================
    // Export Resource Concern Component to Land Use Associations
    exportResourceConcernComponentLandUses() {

        try {
            if (!this._popupValid) {
                this.growlBox.addGrowl("error", "The form is not valid. Please complete all required fields and resolve any errors.");
                throw "error";
            }

            //console.log(`  [${this._componentName}:exportAllRCCLUs()]`);

            //Close the dialog
            this.popExportRCCLU.Close();

            this.growlBox.addGrowl("info", "Exporting RCC-LU...");

            let start_date = this._exportStartDate ? new Date(this._exportStartDate.replace(/-/g, '\/')).toISOString() : null;
            let end_date = this._exportEndDate ? new Date(this._exportEndDate.replace(/-/g, '\/')).toISOString() : null;
            let filterText = this._exportStartDate ? this._exportStartDate + "-" + this._exportEndDate : "";
            let resource_concern_category_id = this._selectedConcernCategory_concernView.resource_concern_category_id != -1 ? this._selectedConcernCategory_concernView.resource_concern_category_id : null;
            let resource_concern_id = null;
            if (this._exportCategorySelected) {
                resource_concern_id = this._selectedResourceConcerns_exportRCCLUPopup.resource_concern_id != -1 ? this._selectedResourceConcerns_exportRCCLUPopup.resource_concern_id : null;
            }
            let resource_concern_component_id = null;
            if (this._exportConcernSelected) {
                resource_concern_component_id = this._selectedConcernComponents_exportRCCLUPopup.resource_concern_component_id != -1 ? this._selectedConcernComponents_exportRCCLUPopup.resource_concern_component_id : null;
            }
            let land_use_id = this._selectedLandUses_exportRCCLUPopup.land_use_id != -1 ? this._selectedLandUses_exportRCCLUPopup.land_use_id : null;
            filterText += this._selectedLandUses_exportRCCLUPopup.land_use_id != -1 ? this._selectedLandUses_exportRCCLUPopup.land_use_name : "";
            if (filterText == "") { filterText = "All"; }

            this.webServices.Get({
                apiPath: "/resource/ExportResourceConcernComponentLandUses",
                args: {
                    startDate: start_date,
                    endDate: end_date,
                    concernCategoryId: resource_concern_category_id,
                    resourceConcernId: resource_concern_id,
                    concernComponentId: resource_concern_component_id,
                    landUseId: land_use_id
                }
            })
                .then(res => {

                    console.log("[{0}:exportResourceConcernComponentLandUses():/resources/ExportResourceConcernComponentLandUses] - res:".format(this._componentName), res);

                    if (!res.data.DTO || res.data.DTO == "") {
                        this.growlBox.addGrowl("info", "No records found for the indicated search.");
                        return;
                    }

                    this.growlBox.addGrowl("success", "Export complete. Sending file to browser.");

                    //Popup in new window
                    exportCsvDTO(res.data.DTO, 'RCCLU', filterText);
                })
                .catch(err => {
                    console.log("An error occured while exporting.", this.cpdFormatters.formatError(err));
                    this.growlBox.addGrowl("error", "An error occured while exporting.");
                });
        }
        catch (e) {
            console.log("An unexpected error occured while exporting", this.cpdFormatters.formatError(e));
            this.growlBox.addGrowl("error", "An unexpected error occured while exporting");
        }
    }

    //=======================================
    // exportResourceConcernResourceConcernComponent
    //=======================================
    exportResourceConcernResourceConcernComponent() {

        try {
            if (!this._popupValid) {
                this.growlBox.addGrowl("error", "The form is not valid. Please complete all required fields and resolve any errors.");
                throw "error";
            }

            //console.log(`  [${this._componentName}:exportAllRCCLUs()]`);

            //Close the dialog
            this.popExportRCRCC.Close();

            this.growlBox.addGrowl("info", "Exporting RC-RCC...");

            let start_date = this._exportStartDateRCRCC ? new Date(this._exportStartDateRCRCC.replace(/-/g, '\/')).toISOString() : null;
            let end_date = this._exportEndDateRCRCC ? new Date(this._exportEndDateRCRCC.replace(/-/g, '\/')).toISOString() : null;
            let resource_concern_category_id = this._selectedConcernCategory_concernView.resource_concern_category_id != -1 ? this._selectedConcernCategory_concernView.resource_concern_category_id : null;
            let resource_concern_id = null;
            if (this._exportCategorySelectedRCRCC) {
                resource_concern_id = this._selectedResourceConcerns_exportRCRCCPopup.resource_concern_id != -1 ? this._selectedResourceConcerns_exportRCRCCPopup.resource_concern_id : null;
            }
            let resource_concern_component_id = null;
            if (this._exportConcernSelectedRCRCC) {
                resource_concern_component_id = this._selectedConcernComponents_exportRCRCCPopup.resource_concern_component_id != -1 ? this._selectedConcernComponents_exportRCRCCPopup.resource_concern_component_id : null;
            }

            this.webServices.Get({
                apiPath: "/resource/ExportResourceConcernResourceConcernComponent",
                args: {
                    startDate: start_date,
                    endDate: end_date,
                    concernCategoryId: resource_concern_category_id,
                    resourceConcernId: resource_concern_id,
                    concernComponentId: resource_concern_component_id
                }
            })
                .then(res => {

                    console.log("[{0}:exportResourceConcernResourceConcernComponent():/resources/ExportResourceConcernResourceConcernComponent] - res:".format(this._componentName), res);

                    if (!res.data.DTO || res.data.DTO == "") {
                        this.growlBox.addGrowl("info", "No records found for the indicated search.");
                        return;
                    }

                    this.growlBox.addGrowl("success", "Export complete. Sending file to browser.");

                    //Popup in new window
                    exportCsvDTO(res.data.DTO, 'RCRCC', 'All');
                })
                .catch(err => {
                    console.log("An error occured while exporting.", this.cpdFormatters.formatError(err));
                    this.growlBox.addGrowl("error", "An error occured while exporting.");
                });
        }
        catch (e) {
            console.log("An unexpected error occured while exporting", this.cpdFormatters.formatError(e));
            this.growlBox.addGrowl("error", "An unexpected error occured while exporting");
        }
    }

    //=======================================
    // flattenRCC_DTO
    //=======================================
    // New DTO format for RCC data is bundelled into objects.  The grid cannot read nested properties.  I tried to add that functionality,
    // but the grid relies too heavily on the flat structure.  The show stopper was sections in the markup that adds "working poperties"
    // to an existing field (making it its own object).  So, we'll just flatten the response form the server back to the old format,
    // but with the new land use data.
    flattenRCC_DTO(dto) {

        let arrOut = [];

        for (let i = 0; i < dto.length; i++) {

            let curRow = dto[i];

            arrOut.push({
                resource_concern_component_id: curRow.component.resource_concern_component_id,
                resource_concern_component_name: curRow.component.resource_concern_component_name,
                resource_concern_component_display: curRow.component.resource_concern_component_display,
                resource_concern_component_description: curRow.component.resource_concern_component_description,
                resource_concern_component_objective: curRow.component.resource_concern_component_objective,
                resource_concern_component_start_date: curRow.component.start_date,
                resource_concern_component_end_date: curRow.component.end_date,
                resource_concern_component_publish: curRow.component.publish,

                resource_concern_id: curRow.concern.resource_concern_id,
                resource_concern_name: curRow.concern.resource_concern_name,
                resource_concern_display: curRow.concern.resource_concern_display,
                resource_concern_description: curRow.concern.resource_concern_description,
                resource_concern_start_date: curRow.concern.start_date,
                resource_concern_end_date: curRow.concern.end_date,
                resource_concern_publish: curRow.concern.publish,
                swapa_category_id: curRow.concern.swapa_category_id,

                resource_concern_category_id: curRow.category.resource_concern_category_id,
                resource_concern_category_name: curRow.category.resource_concern_category_name,
                resource_concern_category_display: curRow.category.resource_concern_category_display,


            });

        }

        console.log("[{0}:flattenRCC_DTO()]:".format(this._componentName), arrOut);

        return arrOut;

    }

    //=======================================
    // saveCategory
    //=======================================
    saveCategory() {

        //Run validation independently, as it modified the screen by setting validation error messages
        let isValid = this.casValidate.isAllValid(true, "popupCategoryFields");

        //Have there been any changes?
        if (!this._popupDirty) {
            alert("No changes detected.");
            return;
        }

        //Is the data valid
        if (!isValid) {
            alert("Please ensure that all field are valid and complete.");
            return;
        }

        //Notify saving to the user
        this.markCategoryGridAsLoading(true);
        this.growlBox.addGrowl("info", "Saving Resource Cateory...");

        //Close the dialog
        this.popCategory.Close();

        //Populate dates from ngbDateParser
        this._popupTempModels.category.categoryStartDate = this._popupTempModels.category.categoryStartDate ? new Date(this._popupTempModels.category.categoryStartDate).toISOString() : null;
        this._popupTempModels.category.categoryEndDate = this._popupTempModels.category.categoryEndDate ? new Date(this._popupTempModels.category.categoryEndDate).toISOString() : null;

        console.log("[{0}:saveCategory()] - _popupTempModels.category:".format(this._componentName), this._popupTempModels.category);

        //Do the deed
        this.webServices.Post("/resource/saveResourceConcernCategory", this._popupTempModels.category)
            .then(res => {
                console.log("[{0}:saveResourceConcernCategory()] - res:".format(this._componentName), res);

                if (res.Success) {

                    //Refresh the currently select FY category info
                    //let fy = this.helpers.getFY(this._popupTempModels.category.categoryStartDate);
                    let fy = this._selectedFiscalYear;

                    //Update the alerts
                    this.growlBox.addGrowl("success", "Save complete");

                    //Do a full refresh of category lists by FY
                    this.initResourceConcernCategoryLists(fy, () => {
                        this.markCategoryGridAsLoading(false);
                    });
                }
                else {
                    this.growlBox.addGrowl("error", this.cpdFormatters.formatError(res));
                    this.markCategoryGridAsLoading(false);
                }

            })
            .catch(err => {
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
                this.markCategoryGridAsLoading(false);
            })

    }

    //=======================================
    // saveComponent
    //=======================================
    saveComponent() {

        //Run validation independently, as it modified the screen by setting validation error messages
        let isValid = this.casValidate.isAllValid(true, "popupComponentFields");

        //Have there been any changes?
        if (!this._popupDirty) {
            alert("No changes detected.");
            return;
        }

        //Is the data valid
        if (!isValid) {
            alert("Please ensure that all field are valid and complete.");
            return;
        }

        //Notify saving to the user
        this.markComponentGridAsLoading(true);
        this.growlBox.addGrowl("info", "Saving Resource Concern Component...");

        //Close the dialog
        this.popComponent.Close();

        //Populate dates from ngbDateParser
        this._popupTempModels.component.componentStartDate = this._popupTempModels.component.componentStartDate ? new Date(this._popupTempModels.component.componentStartDate).toISOString() : null;
        this._popupTempModels.component.componentEndDate = this._popupTempModels.component.componentEndDate ? new Date(this._popupTempModels.component.componentEndDate).toISOString() : null;

        console.log("[{0}:saveComponent()] - _popupTempModels.component:".format(this._componentName), this._popupTempModels.component);

        //Do the deed
        this.webServices.Post("/resource/saveResourceConcernComponent", this._popupTempModels.component)
            .then(res => {
                console.log("[{0}:saveResourceConcernComponent()] - res:".format(this._componentName), res);

                if (res.Success) {

                    //Update the alerts
                    this.growlBox.addGrowl("success", "Save complete");

                    this.componentView_goButtonClicked();
                }
                else {
                    this.growlBox.addGrowl("error", this.cpdFormatters.formatError(res));
                    this.markComponentGridAsLoading(false);
                }

            })
            .catch(err => {
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
                this.markComponentGridAsLoading(false);
            })
    }

    //=======================================
    // saveConcern
    //=======================================
    saveConcern() {

        console.log("this._popupTempModels.concern:", this._popupTempModels.concern);

        //Run validation independently, as it modified the screen by setting validation error messages
        let isValid = this.casValidate.isAllValid(true, "popupConcernFields");

        //Have there been any changes?
        if (!this._popupDirty) {
            alert("No changes detected.");
            return;
        }

        //Is the data valid
        if (!isValid) {
            alert("Please ensure that all field are valid and complete.");
            return;
        }

        //Notify saving to the user
        this.markConcernGridAsLoading(true);
        this.growlBox.addGrowl("info", "Saving Resource Concern...");

        //Close the dialog
        this.popConcern.Close();

        //Populate dates from ngbDateParser
        this._popupTempModels.concern.concernStartDate = this._popupTempModels.concern.concernStartDate ? new Date(this._popupTempModels.concern.concernStartDate).toISOString() : null;
        this._popupTempModels.concern.concernEndDate = this._popupTempModels.concern.concernEndDate ? new Date(this._popupTempModels.concern.concernEndDate).toISOString() : null;

        console.log("[{0}:saveConcern()] - _popupTempModels.concern:".format(this._componentName), this._popupTempModels.concern);

        //Do the deed
        this.webServices.Post("/resource/saveResourceConcern", this._popupTempModels.concern)
            .then(res => {
                console.log("[{0}:saveResourceConcern()] - res:".format(this._componentName), res);

                if (res.Success) {

                    //Update the alerts
                    this.growlBox.addGrowl("success", "Save complete");

                    //Refresh all references to the updated resource concern list
                    this.initResourceConcernLists(this._selectedFiscalYear, true);

                    //Refresh the concern grid separately
                    this.concernView_goButtonClicked();
                }
                else {
                    this.growlBox.addGrowl("error", this.cpdFormatters.formatError(res));
                    this.markConcernGridAsLoading(false);
                }

            })
            .catch(err => {
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
                this.markConcernGridAsLoading(false);
            })
    }

    //=======================================
    // selectedView_changed
    //=======================================
    selectedView_changed(viewName) {

        switch (viewName.toLowerCase()) {

            case "categories":

                this._title = "National - Resource Concern Management - Categories";

                this.casNavBoxService.ShowActionByName("act_new_resource_concern_category");
                this.casNavBoxService.ShowActionByName("act_revise_resource_concern_category");

                this.casNavBoxService.HideActionByName("act_new_resource_concern");
                this.casNavBoxService.HideActionByName("act_revise_resource_concern");

                this.casNavBoxService.HideActionByName("act_new_resource_concern_component");
                this.casNavBoxService.HideActionByName("act_revise_resource_concern_component");
                this.casNavBoxService.HideActionByName("act_land_use");

                this.casNavBoxService.ShowActionByName("act_export_resource_concern_resource_concern_component");
                this.casNavBoxService.ShowActionByName("act_export_resource_concern_component_land_use");

                break;

            case "concerns":

                this._title = "National - Resource Concern Management - Concerns";

                this.casNavBoxService.HideActionByName("act_new_resource_concern_category");
                this.casNavBoxService.HideActionByName("act_revise_resource_concern_category");

                this.casNavBoxService.ShowActionByName("act_new_resource_concern");
                this.casNavBoxService.ShowActionByName("act_revise_resource_concern");

                this.casNavBoxService.HideActionByName("act_new_resource_concern_component");
                this.casNavBoxService.HideActionByName("act_revise_resource_concern_component");
                this.casNavBoxService.HideActionByName("act_land_use");

                this.casNavBoxService.ShowActionByName("act_export_resource_concern_resource_concern_component");
                this.casNavBoxService.ShowActionByName("act_export_resource_concern_component_land_use");

                //Biz wants grid to load on radio click
                this.concernView_goButtonClicked();

                break;

            case "components":

                this._title = "National - Resource Concern Management - Components";

                this.casNavBoxService.HideActionByName("act_new_resource_concern_category");
                this.casNavBoxService.HideActionByName("act_revise_resource_concern_category");

                this.casNavBoxService.HideActionByName("act_new_resource_concern");
                this.casNavBoxService.HideActionByName("act_revise_resource_concern");

                this.casNavBoxService.ShowActionByName("act_new_resource_concern_component");
                this.casNavBoxService.ShowActionByName("act_revise_resource_concern_component");
                this.casNavBoxService.ShowActionByName("act_land_use");

                this.casNavBoxService.ShowActionByName("act_export_resource_concern_resource_concern_component");
                this.casNavBoxService.ShowActionByName("act_export_resource_concern_component_land_use");

                //Biz wants grid to load on radio click
                this.componentView_goButtonClicked();

                break;
        }

        this._sessionStorageObject.currentView = viewName;
        this._saveSessionStorageObject(this._sessionStorageObject);


    }


    // DEBUGGING
    //-------------------------------------------------------------------------------------------------------------------------
    //=======================================
    // debugEntryClicked
    //=======================================
    debugEntryClicked(entry) {
        console.log("[{0}:debugEntryClicked]".replace([0], this._componentName));
        console.log("    ", entry);

        switch (entry) {

            case "Hide":
                this.casNavBoxService.HideActionByName("act_revise_resource_concern");
                break;

            case "Unhide":
                this.casNavBoxService.ShowActionByName("act_revise_resource_concern");
                break;

            case "Test":
                console.log("this.testing_loadResourceConcernComponents2", this.testing_loadResourceConcernComponents2(2022, null, false));

        }
    };


    //=======================================
    // loadResourceConcernComponents2
    //=======================================
    testing_loadResourceConcernComponents2(fy, resourceConcernId, publishedOnly) {

        this.webServices
            .Get({
                apiPath: "/resource/getResourceConcernComponents2",
                args: {
                    fiscalYear: fy,
                    resourceConcernId: resourceConcernId == -1 ? null : resourceConcernId,
                    resourceConcernComponentId: null,
                    publishedOnly: publishedOnly,
                    filterLandUseByFY: false
                }
            })
            .then(res => {
                console.log("[{0}:testing_loadResourceConcernComponents2] - res:".format(this._componentName), res);
            })
            .catch(err => {
                console.log("[{0}:testing_loadResourceConcernComponents2] - ERROR:".format(this._componentName), err);
            });
    }

    //Land Uses Retired Code, saved and commented for future reference

    //Available grid (available land uses list on the left)
    //_availableLandUses_gridSettings = {
    //    height: 120, width: 180, showMessageWhenEmpty: false, hideControlRow: true,
    //    cssClasses_Grid: "rm-cssClasses_Grid",
    //    cssClasses_Cell: "rm-cssClasses_Cell",
    //    cssClasses_Body: "rm-cssClasses_Body",
    //    cssClasses_ColumnHeaderRow: "rm-cssClasses_ColumnHeaderRow",
    //    columns: [{ fieldName: 'land_use_name', display: '', sortable: false, width: '100%' }],
    //    rows: []
    //}

    ////Selected grid (land uses in the right hand list)
    //_selectedLandUses_gridSettings = {
    //    height: 120, width: 180, showMessageWhenEmpty: false, hideControlRow: true,
    //    cssClasses_Grid: "rm-cssClasses_Grid",
    //    cssClasses_Cell: "rm-cssClasses_Cell",
    //    cssClasses_Body: "rm-cssClasses_Body",
    //    cssClasses_ColumnHeaderRow: "rm-cssClasses_ColumnHeaderRow",
    //    columns: [{ fieldName: 'land_use_name', display: '', sortable: false, width: '100%' }],
    //    rows: []
    //}

    //==================================
    // _addAllLandUses
    //==================================
    // Adds all land uses to the selected land use list
    //_addAllLandUses() {

    //    if (this._allFieldsDisabled) { return; }

    //    this._popupDirty = true;

    //    //Get buffer references to the array for off screen work
    //    var arrSource = this._availableLandUses_gridSettings.rows;
    //    var arrDest = this._selectedLandUses_gridSettings.rows;

    //    //Clear the display while we work by clearing the grid references to the array in memory
    //    this._availableLandUses_gridSettings.rows = [];
    //    this._selectedLandUses_gridSettings.rows = [];

    //    //Move the land uses in the buffer arrays
    //    while (arrSource.length > 0) {
    //        arrDest.push(arrSource.splice(0, 1)[0]);
    //    }

    //    //Sort the populated array
    //    this._sortLandUseData(arrDest);

    //    //Assign the array back to the populated list
    //    this._selectedLandUses_gridSettings.rows = arrDest;

    //    //Update the resource concern's selected land uses list
    //    this._syncConcernToLandUseList();
    //};

    //==================================
    // _removeAllLandUses
    //==================================
    // Removes all selected land uses from the selected list and adds them to the available land uses list
    //_removeAllLandUses() {

    //    if (this._allFieldsDisabled) { return; }

    //    this._popupDirty = true;

    //    //Get buffer references to the array for off screen work
    //    var arrSource = this._selectedLandUses_gridSettings.rows;
    //    var arrDest = this._availableLandUses_gridSettings.rows;

    //    //Clear the display while we work by clearing the grid references to the array in memory
    //    this._selectedLandUses_gridSettings.rows = [];
    //    this._availableLandUses_gridSettings.rows = [];

    //    //Move the land uses in the buffer arrays
    //    while (arrSource.length > 0) {
    //        arrDest.push(arrSource.splice(0, 1)[0]);
    //    }

    //    //Sort the populated array
    //    this._sortLandUseData(arrDest);

    //    //Assign the array back to the populated list
    //    this._availableLandUses_gridSettings.rows = arrDest;

    //    //Update the concern's selected land uses list
    //    this._syncConcernToLandUseList();
    //};

    //==================================
    // _selectedLandUsesGrid_rowSelected
    //==================================
    // Moves a land use from the selected list to the available list
    //_selectedLandUsesGrid_rowSelected(e) {

    //    this._popupDirty = true;

    //    var arrSource = this._selectedLandUses_gridSettings.rows;
    //    var arrDest = this._availableLandUses_gridSettings.rows;

    //    //Pull the selected item out of the authorized grid
    //    let landUse = arrSource.splice(arrSource.findIndex(lu => lu.land_use_id == e.land_use_id), 1)[0]; //splice returns an array

    //    //Move the land use into the available list
    //    arrDest.push(landUse);

    //    //Make sure the pushed row isn't flagged as selected
    //    this.availableLandUsesGrid.UnselectAllRows();

    //    //Resort the receiving list
    //    this._sortLandUseData(arrDest);

    //    //Update the concern's selected land uses list
    //    this._syncConcernToLandUseList();
    //};

    //==================================
    // _availableLandUsesGrid_rowSelected
    //==================================
    //_availableLandUsesGrid_rowSelected(e) {

    //    this._popupDirty = true;

    //    let arrSource = this._availableLandUses_gridSettings.rows;
    //    let arrDest = this._selectedLandUses_gridSettings.rows;

    //    //Pull the selected item out of the selected grid
    //    let landUse = arrSource.splice(arrSource.findIndex(lu => lu.land_use_id == e.land_use_id), 1)[0]; //splice returns an array

    //    //Move the land use into the selected list
    //    arrDest.push(landUse);

    //    //Make sure the pushed row isn't flagged as selected
    //    this.selectedLandUsesGrid.UnselectAllRows();

    //    //Resort the receiving list
    //    this._sortLandUseData(arrDest);

    //    //Update the concern's selected land uses list
    //    this._syncConcernToLandUseList();
    //};

    //==================================
    // _populateLandUses
    //==================================
    //_populateLandUses() {

    //    //Clear the land use lists
    //    this._availableLandUses_gridSettings.rows = [];
    //    this._selectedLandUses_gridSettings.rows = []

    //    //Temp variables so we can sort "offscreen"
    //    let selectedLUs = [];
    //    let availableLUs = [];

    //    let resourceConcernId = this._popupTempModels.component.componentId;

    //    //Load the land uses for the component from the server if revise
    //    this.webServices.Get({
    //        apiPath: "/resource/GetResourceConcernComponentLandUses",
    //        args: {
    //            resourceConcernId: resourceConcernId == null ? 0 : resourceConcernId
    //        }
    //    })
    //        .then((res) => {
    //            console.log("[resourceManagement:GetResourceConcernComponentLandUses():Get()] (/resource/getResourceConcernComponentLandUses, Default) res:", res);

    //            let dto = res.data.DTO;
    //            this._popupTempModels.component.componentLandUses = dto;

    //            //Load the land uses from the server (will be cached after the first time)
    //            //(We clone these because we are going to pull them out of the returned array and put them into two separate collections)
    //            this.webServices.GetCached({
    //                apiPath: "/landuse/getLandUses",
    //                clone: true,
    //                args: {
    //                    fy: this._selectedFiscalYear
    //                }
    //            })
    //                .then((res) => {
    //                    console.log("[resourceManagement:_populateLandUses$():GetCached()] (/landuse/getLandUses, Default) res:", res);

    //                    let allLandUses = res.data.DTO;

    //                    let filteredAllLandUses = this._filterLandUses(allLandUses);

    //                    //Move land units that are in the concern's selected list from the
    //                    //allLandUnits array into the selected land units array
    //                    this._popupTempModels.component.componentLandUses = this._popupTempModels.component.componentLandUses || [];
    //                    for (let selectedLandUse of this._popupTempModels.component.componentLandUses) {

    //                        //Find this land use by its land_use_id in the full land uses list
    //                        let idx = filteredAllLandUses.findIndex((landUse) => { return landUse.land_use_id == selectedLandUse.land_use_id });

    //                        //This shouldn't happen, but let's keep it silent if it does
    //                        if (idx == -1) { continue; }

    //                        //Move the land use into the selected land use list
    //                        selectedLUs.push(filteredAllLandUses.splice(idx, 1)[0]);
    //                    }

    //                    //Set the available land uses list to the remaining land uses in the allLandUses list
    //                    availableLUs = filteredAllLandUses;

    //                    //Sort the arrays
    //                    this._sortLandUseData(selectedLUs);
    //                    this._sortLandUseData(availableLUs);

    //                    //Render the lists on screen
    //                    this._availableLandUses_gridSettings.rows = availableLUs;
    //                    this._selectedLandUses_gridSettings.rows = selectedLUs;

    //                });
    //        });

    //};

    //==================================
    // _sortLandUseData
    //==================================
    //_sortLandUseData(arr) {
    //    arr.sort((row1, row2) => {
    //        return row1.land_use_name < row2.land_use_name ? -1 : (row1.land_use_name > row2.land_use_name ? 1 : 0);
    //    });
    //};

    //==================================
    // _syncConcernToLandUseList
    //==================================
    // This function looks at the current available and selected lists/grids and syncs the
    // current concern's selected land uses based on them (specifically the selected list)
    //_syncConcernToLandUseList() {
    //    this._popupTempModels.component.componentLandUses = [];
    //    let selectedLUs = this._selectedLandUses_gridSettings.rows;
    //    for (let landUse of selectedLUs) {
    //        this._popupTempModels.component.componentLandUses.push(landUse);
    //    }

    //    this._formChanged("popComponent_body");
    //};

    //=======================================
    // __validateSelectedLandUsesGrid
    //=======================================
    //_validateSelectedLandUsesGrid(el) {
    //    if (this[el.id].settings.rows.length == 0) {
    //        return { valid: false, msg: "At least one Land Use is required." }
    //    }
    //    return { valid: true, msg: "" }
    //}


}//component

